// Self-contained translations for the Liquidity Map module.
export const LIQMAP_T = {
  es: {
    title: "Liquidity Map",
    subtitle: "Mapa de liquidaciones agregado · 12 exchanges",
    live: "EN VIVO",
    exchanges: "exchanges",
    loading: "Cargando…",
    guest_title: "Necesitas una cuenta gratis",
    guest_sub: "Liquidity Map muestra clusters de liquidación en tiempo real de 12 exchanges. Crea tu cuenta gratis en 30 segundos y accede a un trial completo.",
    guest_cta_register: "Crear cuenta gratis",
    guest_cta_login: "Ya tengo cuenta",
    err_insufficient: "Datos insuficientes en este momento. Reintentando…",
    err_load: "No pudimos cargar los datos. Reintentando…",
    coins: { BTC: "Bitcoin", ETH: "Ethereum", SOL: "Solana", BNB: "BNB", XRP: "XRP", ZEC: "Zcash" },
    stats: {
      price: "Precio",
      change24: "24h%",
      oi: "Open Interest",
      liq_longs: "EXPOSICIÓN LIQ LONGS",
      liq_shorts: "EXPOSICIÓN LIQ SHORTS",
      liq_longs_tooltip: "Exposición estimada a liquidaciones basada en OI y densidad de clusters. Liquidaciones reales en tiempo real: próximamente.",
      liq_shorts_tooltip: "Exposición estimada a liquidaciones basada en OI y densidad de clusters. Liquidaciones reales en tiempo real: próximamente.",
      // ── Opción B (liqs reales WS) — 2026-02-23 ──────────────────────────
      liq_longs_real: "LIQ LONGS 24H",
      liq_shorts_real: "LIQ SHORTS 24H",
      liq_real_tooltip: "Liquidaciones reales agregadas de OKX, Bitget e Hyperliquid en las últimas 24h. Excluye Binance/Bybit (restricción geográfica).",
      liq_real_badge_live: "EN VIVO · OKX/BG/HL",
      liq_real_badge_partial: "PARCIAL · {n}/3 fuentes",
      liq_real_badge_degraded: "DEGRADADO · 1/3 fuente",
      liq_real_badge_offline: "OFFLINE · sin feed",
      liq_real_badge_warming: "WARMING UP · {m}m restantes",
      liq_real_partial_hl_note: "Hyperliquid no lista esta moneda.",
      cluster_max: "Cluster máx",
    },
    wyckoff: {
      title_overline: "ANÁLISIS",
      title: "Estructura de Mercado",
      open_btn_label: "📐 Estructura",
      open_btn_title: "Ver análisis de estructura de mercado (rango, eventos, contexto)",
      loading: "Cargando análisis…",
      error: "No pudimos cargar el análisis. Reintentando…",
      range_section_title: "Rango activo",
      ranging_yes: "✓ Sí",
      ranging_no: "— No detectado",
      confidence: "Confianza",
      range_high: "Techo",
      range_low: "Suelo",
      midpoint: "Medio",
      range_pct: "Amplitud",
      window_label: "Ventana",
      duration_label: "Duración en rango",
      duration_tier_extended: "consolidación extendida",
      duration_tier_major: "compresión mayor",
      candles_unit: "velas",
      no_range_hint: "El precio no muestra un rango claro en este timeframe. Probá uno más amplio (4h, 1d).",
      events_section_title: "Eventos detectados",
      no_events: "Sin eventos relevantes en este timeframe.",
      spring_label: "Posible Spring",
      utad_label: "Posible UTAD",
      sc_label: "Posible Selling Climax",
      bc_label: "Posible Buying Climax",
      cluster_at: "Cluster",
      conviction_high: "convicción alta",
      conviction_medium: "convicción media",
      conviction_low: "convicción baja",
      conviction_unknown: "convicción ND",
      cluster_section_title: "Contexto de clusters",
      cluster_max: "Principal",
      cluster_second: "Secundario",
      cluster_hint: "Los clusters de liquidación son los Creek/Ice del rango Wyckoff — zonas donde la estructura puede romperse o sostenerse.",
      badge_ranging: "📐 RANGO ACTIVO · {tf}",
      badge_no_range: "📐 ESTRUCTURA · {tf}",
      share_to_shadow: "Compartir a Shadow",
      share_capture_failed: "No se pudo capturar el análisis",
    },
    trial: {
      days_left_one: "1 día restante",
      days_left_many: "{n} días restantes",
      expired_title: "Tu prueba gratuita ha terminado",
      expired_strong: "prueba gratuita",
      expired_sub: "Desbloquea el Liquidity Map con datos reales de 12 exchanges.",
      cta_lifetime: "Obtener acceso PRO vitalicio →",
      cta_rbl: "Pagar con R₿L on-chain -50%",
      cta_back: "Volver al inicio",
      lifetime_note: "⏳ Oferta vitalicia disponible hasta el 2 de agosto de 2026",
      pro_active: "PRO ACTIVO",
    },
    cascade: {
      source_label: "fuente",
      predictor_ia_label: "Predictor IA",
      cascade_timer_label: "Cascade Timer",
      info_aria: "Cómo se calcula esta fuente",
      predictor_ia_info:
        "Estimación generada por IA (Claude) a partir de contexto de mercado en tiempo real: precio, cluster, distancia, funding, liquidaciones recientes. Es un análisis cualitativo, no una fórmula fija. Se verifica después contra el precio real (touch-then-bounce).",
      cascade_timer_info:
        "Estimación calculada con una fórmula cuantitativa: velocidad histórica del precio hacia el cluster, funding rate, ratio de liquidaciones longs/shorts, y ajustada por la calidad validada del cluster. Se verifica después contra el precio real (touch-then-bounce).",
      analysis_low_score:
        "Riesgo bajo — el análisis IA detallado se activa a partir de score 31/100.",
      coverage_disclaimer:
        "La cobertura es mayor en las monedas que más visitás — recorré las pestañas para ampliar el histórico de las demás.",
      monitoring_sr:
        "Monitoreando — sin setup confirmado aún",
      monitoring_predictor:
        "Monitoreando — sin predicción confirmada aún",
      // Risk labels (predictor banner)
      risk_imminent: "CASCADA INMINENTE",
      risk_high: "RIESGO ALTO",
      risk_moderate: "RIESGO MODERADO",
      risk_low: "RIESGO BAJO",
      // Structured stats row
      label_price: "Precio",
      label_cluster: "Cluster",
      label_distance: "Distancia",
      // Banner footer
      analyzing_ai: "Analizando con IA RE₿EL...",
      updated_ago: "Actualizado hace {n}s",
      cache_active: "Caché activo",
      local_analysis: "análisis local",
      history_btn: "Historial",
      history_btn_title: "Abre el panel 'Predicciones Recientes' (verificadas por touch-then-bounce) filtrado al coin actual.",
      // Cascade Timer countdown panel
      zone_critical: "⚡ ZONA CRÍTICA",
      estimated_cascade: "⏱️ CASCADA ESTIMADA",
      pressure_relieved: "⏸ PRESIÓN ALIVIADA — precio alejándose del cluster",
      cluster_reached: "⚡ CLUSTER ALCANZADO — CASCADA INICIADA",
      probability: "PROBABILIDAD",
      validated_footer: "Validado: {venues} venues · {pct}% liqs reales",
      trend_lateral: "LATERAL",
      trend_bullish: "ALCISTA",
      trend_bearish: "BAJISTA",
      // Historial drawer
      history_title: "HISTORIAL CASCADAS",
      history_empty: "Sin alertas registradas para {coin}",
      history_close_aria: "Cerrar historial",
      banner_close_aria: "Cerrar banner",
    },
    toolbar: {
      whales: "🐋 Ballenas",
      whales_title: "Mostrar/ocultar ballenas (>$1M) y órdenes medianas ($100K+)",
      sr_ai: "📐 S/R IA",
      sr_ai_title: "Soportes y resistencias detectados con IA",
      sr_setups_hot: "{n} setup{s} de alta probabilidad detectado{s}",
      range: "↕ Rango",
      range_title: "Rango de negociación: máximo y mínimo de las velas visibles (se ajusta al brush)",
      trendline: "📈 Tendencia",
      trendline_title: "Línea de tendencia: une los pivotes recientes y la proyecta",
      patterns: "◆ Patrones",
      patterns_title: "Patrones chartistas: Doble Techo/Suelo, Triángulos y HCH (calibración per-coin)",
      candles: "🕯 Velas",
      candles_title: "Patrones de vela: Hammer, Hanging Man, Inv. Hammer, Shooting Star, Doji, Engulfing",
      ema: "📈 EMA",
      ema_title: "EMAs 9/21/50/200 con detección de cruces (Golden/Death, 21×50, 9×21). Relevancia depende del timeframe.",
      structure_default: "Estructura",
      historical: "📜 Histórico",
      historical_title: "Histórico de setups detectados y su % real de acierto",
      predictions: "📊 Predicciones",
      predictions_title: "Histórico de predicciones del Cascade Predictor IA y su % real de acierto",
      timer: "⏱️ Timer",
      timer_title: "Histórico del Cascade Timer (countdown vs tiempo real)",
      stochastic: "📊 Estocástico",
      stochastic_title: "Oscilador Estocástico (K=14, D=3, Smooth=3) — muestra momentum y zonas de sobrecompra/sobreventa",
    },
    stochastic: {
      overbought: "SOBRECOMPRA",
      oversold: "SOBREVENTA",
      neutral: "NEUTRO",
      signal_bull: "Cruce alcista en sobreventa",
      signal_bear: "Cruce bajista en sobrecompra",
    },
    composite: {
      title: "Señal Compuesta",
      verdicts: {
        STRONG_BUY: "COMPRA FUERTE",
        BUY: "COMPRA",
        NEUTRAL: "NEUTRAL",
        SELL: "VENTA",
        STRONG_SELL: "VENTA FUERTE",
      },
      presets: { conservador: "Cons", balanceado: "Bal", agresivo: "Agr" },
      preset_titles: {
        conservador: "Conservador — pondera EMA y Wyckoff (señales lentas)",
        balanceado: "Balanceado — mix parejo entre todos los indicadores",
        agresivo: "Agresivo — pondera Stochastic y Cascade (mean-reversion rápido)",
      },
      custom_short: "CUST",
      custom_title: "Configura pesos personalizados",
      custom_locked: "Personalización disponible en RE₿EL PRO",
      delayed: "DIFERIDO 5 MIN",
      breakdown_title: "Contribuyentes activos",
      no_signals: "Sin señales activas — activa toggles del chart",
      disclaimer: "Score compuesto de indicadores activos. No es asesoramiento financiero.",
      contrib: {
        ema: "Cruce EMA",
        stochastic: "Cruce Estocástico",
        cluster: "Proximidad a cluster",
        wyckoff: "Estructura Wyckoff",
        cascade: "Predictor cascada",
      },
    },
    sr_top: {
      btn_label: "🏆 Top S/R",
      btn_title: "Top niveles S/R cross-coin ordenados por score de fuerza",
      panel_title: "Top niveles S/R",
      panel_subtitle: "Ranking cross-coin por score de fuerza compuesto",
      tf_label: "Timeframe",
      limit_label: "Top",
      coin_filter_label: "Moneda",
      coin_all: "TODAS",
      empty: "No hay niveles disponibles en este timeframe.",
      empty_coin: "No hay niveles para {coin} en este timeframe.",
      loading: "Cargando ranking…",
      err: "No pudimos cargar el ranking. Reintentando…",
      col_rank: "#",
      col_coin: "Moneda",
      col_kind: "Tipo",
      col_price: "Precio",
      col_score: "Score",
      col_tasa: "Éxito",
      col_toques: "Toques",
      col_dist: "Distancia",
      kind_R: "Resistencia",
      kind_S: "Soporte",
      tier_fuerte: "FUERTE",
      tier_media: "MEDIO",
      tier_debil: "DÉBIL",
      footer_hint:
        "El score combina éxito histórico (40%) + nº toques (25%) + recencia (20%) + proximidad (15%). Solo niveles reales — los placeholders de cobertura no entran al ranking.",
    },
    range_tooltip: {
      // Used by the Range overlay (HeatmapCanvas) to show when each extreme
      // was first registered. {date} is pre-formatted by the caller.
      min_prefix: "MÍN visto",
      max_prefix: "MÁX visto",
      candle_of: "vela de",
      on: "el",
    },
    trend_tooltip: {
      title: "Pivotes de la tendencia",
      anchor: "Anclaje",
      intermediate: "Pivote intermedio",
      hint_anchor: "La línea pasa exactamente por estos puntos.",
      hint_intermediate: "Validan la dirección pero no influyen en la línea.",
      kind_low: "Mínimo (swing low)",
      kind_high: "Máximo (swing high)",
      total_pivots: "{n} pivotes",
      delta_summary: "Δ {pct} · {n} velas",
      empty: "Sin pivotes detectados.",
    },
    patterns: {
      label_double_top: "Doble Techo",
      label_double_bottom: "Doble Suelo",
      status_confirmed: "confirmado",
      status_forming: "formándose",
      status_invalidated: "invalidado",
      invalidated_badge: "✗ INVALIDADO",
      invalidated_reason_doubletop: "precio cerró por encima de los picos",
      invalidated_reason_doublebottom: "precio cerró por debajo de los mínimos",
      invalidated_reason_hs: "precio cerró por encima de la cabeza",
      invalidated_reason_inv_hs: "precio cerró por debajo de la cabeza",
      invalidated_reason_triangle_asc: "precio rompió a la baja (Asc esperaba ruptura alcista)",
      invalidated_reason_triangle_desc: "precio rompió al alza (Desc esperaba ruptura bajista)",
      tooltip_invalidation: "Invalidación @ {price}",
      no_pattern: "Sin patrón detectado",
      neckline_at: "Neckline en {price}",
      pending_break: "falta romper neckline",
      pending_break_triangle: "vértice pendiente",
      triangle_ascending: "Triángulo Ascendente",
      triangle_descending: "Triángulo Descendente",
      triangle_symmetric: "Triángulo Simétrico",
      tooltip_title_top: "Doble Techo · {status}",
      tooltip_title_bottom: "Doble Suelo · {status}",
      tooltip_peak1: "Pico 1",
      tooltip_peak2: "Pico 2",
      tooltip_valley: "Valle (neckline)",
      tooltip_bottom1: "Mínimo 1",
      tooltip_bottom2: "Mínimo 2",
      tooltip_ridge: "Cresta (neckline)",
      tooltip_high_pivot: "Pivote alto",
      tooltip_low_pivot: "Pivote bajo",
      tooltip_neckline: "Neckline",
      tooltip_break: "Rotura",
      tooltip_calibrated: "Tolerancia {coin}: ±{tol}%",
      tooltip_fallback: "Tolerancia pooled: ±{tol}% ({coin} sin calibrar)",
      tooltip_triangle_flat: "Flat {coin}: ≤{flat}%/vela",
      tooltip_triangle_flat_pooled: "Flat pooled: ≤{flat}%/vela ({coin} sin calibrar)",
      // ── Head & Shoulders ─────────────────────────────────────────
      label_hs: "Hombro-Cabeza-Hombro",
      label_inv_hs: "HCH Invertido",
      tooltip_ls: "Hombro Izq.",
      tooltip_head: "Cabeza",
      tooltip_rs: "Hombro Der.",
      tooltip_neckline_diag: "Neckline (diagonal)",
      tooltip_head_diff: "Δ cabeza-hombros",
      tooltip_shoulder_diff: "Δ entre hombros",
      tooltip_hch_calibrated: "Cabeza ≥ {head}% · Δ hombros ≤ {shoulder}% ({coin})",
      tooltip_hch_pooled: "Cabeza ≥ {head}% · Δ hombros ≤ {shoulder}% (pooled, {coin} sin calibrar)",
      // ── Candlestick patterns ─────────────────────────────────────
      candle_hammer: "Hammer",
      candle_hanging_man: "Hanging Man",
      candle_inverted_hammer: "Inverted Hammer",
      candle_shooting_star: "Shooting Star",
      candle_doji: "Doji",
      candle_engulfing_bull: "Engulfing Alcista",
      candle_engulfing_bear: "Engulfing Bajista",
      candle_signal_bullish: "alcista",
      candle_signal_bearish: "bajista",
      candle_signal_neutral: "neutral",
      candle_body_ratio: "Cuerpo / rango",
      candle_engulf_ratio: "Razón engulf",
      candle_lower_wick: "Mecha inferior",
      candle_upper_wick: "Mecha superior",
      candle_drift: "Drift (ctx)",
      candle_no_pattern: "Sin patrón de vela",
      // ── Mini legend (DOM, left-edge collapsible) ────────────────
      candle_legend_title: "Velas",
      candle_legend_doji: "Doji",
      candle_legend_hammer: "Hammer · Hanging Man",
      candle_legend_inv_hammer: "Inv. Hammer · Shooting Star",
      candle_legend_engulfing: "Engulfing",
      candle_legend_cluster: "Cúmulo (N velas próximas)",
      candle_legend_collapse: "Contraer leyenda",
      candle_legend_expand: "Expandir leyenda",
      candle_legend_count: "{n} patrón(es) en rango",
      // ── Manual drawing tools (Fase B1) ──────────────────────────
      drawing: {
        toggle_title: "Herramientas de dibujo manual",
        toggle_label: "Dibujar",
        tool_cursor: "Cursor (pan/zoom)",
        tool_line: "Línea de tendencia",
        tool_horizontal: "Línea horizontal",
        tool_vertical: "Línea vertical",
        tool_rect: "Rectángulo",
        tool_text: "Texto",
        tool_eraser: "Borrar",
        tool_magnet: "Imán: ajustar a vela (OHLC)",
        tool_measure: "Medidor (transitorio)",
        tool_fib_ret: "Fibonacci Retracement",
        tool_fib_ext: "Fibonacci Extension",
        tool_channel: "Canal paralelo (3 clicks)",
        tool_position: "Posición Long/Short (3 clicks)",
        tool_circle: "Círculo",
        tool_ellipse: "Elipse",
        tool_triangle: "Triángulo (3 clicks)",
        tool_freehand: "Pincel libre",
        tool_polyline: "Polilínea (dbl-click/Enter)",
        tool_callout: "Callout (flecha + texto)",
        tool_flag: "Flag / Signpost",
        tool_fib_timezone: "Fib Time Zone",
        tool_fib_speedfan: "Fib Speed Resistance Fan",
        tool_fib_wedge: "Fib Wedge",
        tool_xabcd: "XABCD (5 clicks)",
        tool_cypher: "Cypher (5 clicks)",
        tool_three_drives: "Three Drives (3 clicks)",
        tool_elliott_imp: "Elliott Impulso (5 clicks)",
        tool_elliott_corr: "Elliott Corrección (3 clicks)",
        tool_gann_fan: "Gann Fan (2 anchors)",
        tool_gann_box: "Gann Box (2 anchors)",
        // Fase B5a — nuevas tools (12)
        tool_highlighter: "Resaltador",
        tool_pitchfork: "Pitchfork de Andrews (3 clicks)",
        tool_fib_channel: "Fib Channel",
        tool_fib_ext_trend: "Fib Extension por Tendencia (3 clicks)",
        tool_forecast: "Forecast / Proyección",
        tool_price_range: "Medir rango (precio)",
        tool_date_range: "Medir rango (fecha)",
        tool_date_price_range: "Medir rango (fecha + precio)",
        tool_abcd: "ABCD manual (4 clicks)",
        tool_head_shoulders: "Cabeza y Hombros (7 clicks)",
        tool_triangle_pattern: "Triángulo (chartist, 4 clicks)",
        tool_cycle_lines: "Líneas cíclicas",
        tool_bars_pattern: "Patrón de barras (capturar + reposicionar)",
        // Fase B6 — professional gaps
        tool_ray: "Ray (línea infinita en una dirección)",
        tool_horizontal_ray: "Horizontal ray (solo hacia la derecha)",
        tool_vertical_ray: "Vertical ray (solo hacia arriba)",
        tool_flag_chartist: "Flag / Pennant / Wedge chartist (4 clicks)",
        tool_schiff_pitchfork: "Schiff Pitchfork (3 clicks)",
        tool_modified_schiff_pitchfork: "Modified Schiff Pitchfork (3 clicks)",
        tool_cup_handle: "Cup & Handle (5 clicks)",
        tool_share: "Compartir dibujos como enlace",
        share_empty: "No hay dibujos para compartir",
        share_copied: "Permalink copiado ({n} dibujos · {kb} KB)",
        share_imported: "{n} dibujos importados",
        share_fallback: "Copiá este enlace:",
        // Categorías de la toolbar
        group_lineas: "Líneas",
        group_fib: "Fibonacci y Gann",
        group_patrones: "Patrones",
        group_prediccion: "Predicción y medición",
        group_formas: "Formas",
        group_anotacion: "Anotación",
        toggle_persistent: "Modo dibujo persistente",
        toggle_lock_all: "Bloquear todos los dibujos",
        toggle_hide_all: "Ocultar todos los dibujos",
        ctx_lock: "Bloquear",
        ctx_unlock: "Desbloquear",
        ctx_hide: "Ocultar",
        ctx_show: "Mostrar",
        ctx_clone: "Clonar",
        ctx_delete: "Eliminar",
        ctx_color: "Color",
        ctx_width: "Grosor",
        ctx_width_thin: "Fino",
        ctx_width_normal: "Normal",
        ctx_width_thick: "Grueso",
        ctx_width_bold: "Bold",
        ctx_color_custom: "Personalizado",
        ctx_width_locked_tooltip: "Fijo para mantener el efecto resaltador",
        ctx_apply_to_type: "Aplicar estilo a todos ({n})",
        undo_empty: "No hay más pasos para deshacer",
        redo_empty: "No hay más pasos para rehacer",
        prompt_flag: "Etiqueta del flag:",
        prompt_callout: "Texto del callout:",
        tool_clear_all: "Borrar todos los dibujos",
        prompt_text: "Texto:",
        confirm_clear_all: "¿Borrar todos los dibujos de esta vista?",
      },
    },
  },
  en: {
    title: "Liquidity Map",
    subtitle: "Aggregated liquidations map · 12 exchanges",
    live: "LIVE",
    exchanges: "exchanges",
    loading: "Loading…",
    guest_title: "You need a free account",
    guest_sub: "Liquidity Map shows real-time liquidation clusters aggregated from 12 exchanges. Create your free account in 30 seconds and get a full trial.",
    guest_cta_register: "Create free account",
    guest_cta_login: "I already have an account",
    err_insufficient: "Insufficient data right now. Retrying…",
    err_load: "Could not load data. Retrying…",
    coins: { BTC: "Bitcoin", ETH: "Ethereum", SOL: "Solana", BNB: "BNB", XRP: "XRP", ZEC: "Zcash" },
    stats: {
      price: "Price",
      change24: "24h%",
      oi: "Open Interest",
      liq_longs: "LONG LIQ EXPOSURE",
      liq_shorts: "SHORT LIQ EXPOSURE",
      liq_longs_tooltip: "Estimated liquidation exposure based on OI and cluster density. Real-time liquidations: coming soon.",
      liq_shorts_tooltip: "Estimated liquidation exposure based on OI and cluster density. Real-time liquidations: coming soon.",
      // ── Opción B (real WS liqs) — 2026-02-23 ────────────────────────────
      liq_longs_real: "LONG LIQ 24H",
      liq_shorts_real: "SHORT LIQ 24H",
      liq_real_tooltip: "Real liquidations aggregated from OKX, Bitget and Hyperliquid over the past 24h. Excludes Binance/Bybit (geographic restriction).",
      liq_real_badge_live: "LIVE · OKX/BG/HL",
      liq_real_badge_partial: "PARTIAL · {n}/3 sources",
      liq_real_badge_degraded: "DEGRADED · 1/3 source",
      liq_real_badge_offline: "OFFLINE · no feed",
      liq_real_badge_warming: "WARMING UP · {m}m left",
      liq_real_partial_hl_note: "Hyperliquid does not list this coin.",
      cluster_max: "Max cluster",
    },
    wyckoff: {
      title_overline: "ANALYSIS",
      title: "Market Structure",
      open_btn_label: "📐 Structure",
      open_btn_title: "View market structure analysis (range, events, context)",
      loading: "Loading analysis…",
      error: "Could not load the analysis. Retrying…",
      range_section_title: "Active range",
      ranging_yes: "✓ Yes",
      ranging_no: "— Not detected",
      confidence: "Confidence",
      range_high: "Top",
      range_low: "Bottom",
      midpoint: "Midpoint",
      range_pct: "Width",
      window_label: "Window",
      duration_label: "Time in range",
      duration_tier_extended: "extended consolidation",
      duration_tier_major: "major compression",
      candles_unit: "candles",
      no_range_hint: "Price doesn't show a clear range in this timeframe. Try a wider one (4h, 1d).",
      events_section_title: "Detected events",
      no_events: "No relevant events in this timeframe.",
      spring_label: "Possible Spring",
      utad_label: "Possible UTAD",
      sc_label: "Possible Selling Climax",
      bc_label: "Possible Buying Climax",
      cluster_at: "Cluster",
      conviction_high: "high conviction",
      conviction_medium: "medium conviction",
      conviction_low: "low conviction",
      conviction_unknown: "conviction N/A",
      cluster_section_title: "Cluster context",
      cluster_max: "Primary",
      cluster_second: "Secondary",
      cluster_hint: "Liquidation clusters are the Creek/Ice of the Wyckoff range — zones where structure can break or hold.",
      badge_ranging: "📐 ACTIVE RANGE · {tf}",
      badge_no_range: "📐 STRUCTURE · {tf}",
      share_to_shadow: "Share to Shadow",
      share_capture_failed: "Could not capture the analysis",
    },
    trial: {
      days_left_one: "1 day left",
      days_left_many: "{n} days left",
      expired_title: "Your free trial has ended",
      expired_strong: "free trial",
      expired_sub: "Unlock the Liquidity Map with real data from 12 exchanges.",
      cta_lifetime: "Get lifetime PRO access →",
      cta_rbl: "Pay with R₿L on-chain -50%",
      cta_back: "Back home",
      lifetime_note: "⏳ Lifetime offer available until August 2nd, 2026",
      pro_active: "PRO ACTIVE",
    },
    cascade: {
      source_label: "source",
      predictor_ia_label: "AI Predictor",
      cascade_timer_label: "Cascade Timer",
      info_aria: "How this source is calculated",
      predictor_ia_info:
        "Estimate generated by AI (Claude) from real-time market context: price, cluster, distance, funding, recent liquidations. It's a qualitative reading, not a fixed formula. It is later verified against the real price (touch-then-bounce).",
      cascade_timer_info:
        "Estimate computed with a quantitative formula: historical price velocity toward the cluster, funding rate, longs/shorts liquidation ratio, capped by the validated cluster quality. It is later verified against the real price (touch-then-bounce).",
      analysis_low_score:
        "Low risk — detailed AI analysis activates from score 31/100.",
      coverage_disclaimer:
        "Coverage is higher on the coins you visit most — cycle through the tabs to expand the history of the others.",
      monitoring_sr:
        "Monitoring — no confirmed setup yet",
      monitoring_predictor:
        "Monitoring — no confirmed prediction yet",
      risk_imminent: "IMMINENT CASCADE",
      risk_high: "HIGH RISK",
      risk_moderate: "MODERATE RISK",
      risk_low: "LOW RISK",
      label_price: "Price",
      label_cluster: "Cluster",
      label_distance: "Distance",
      analyzing_ai: "Analyzing with RE₿EL AI...",
      updated_ago: "Updated {n}s ago",
      cache_active: "Cache active",
      local_analysis: "local analysis",
      history_btn: "History",
      history_btn_title: "Opens the 'Recent Predictions' panel (touch-then-bounce verified) filtered to the current coin.",
      zone_critical: "⚡ CRITICAL ZONE",
      estimated_cascade: "⏱️ ESTIMATED CASCADE",
      pressure_relieved: "⏸ PRESSURE RELIEVED — price moving away from cluster",
      cluster_reached: "⚡ CLUSTER REACHED — CASCADE STARTED",
      probability: "PROBABILITY",
      validated_footer: "Validated: {venues} venues · {pct}% real liqs",
      trend_lateral: "SIDEWAYS",
      trend_bullish: "BULLISH",
      trend_bearish: "BEARISH",
      history_title: "CASCADE HISTORY",
      history_empty: "No alerts recorded for {coin}",
      history_close_aria: "Close history",
      banner_close_aria: "Close banner",
    },
    toolbar: {
      whales: "🐋 Whales",
      whales_title: "Show/hide whales (>$1M) and mid-size orders ($100K+)",
      sr_ai: "📐 S/R AI",
      sr_ai_title: "AI-detected supports and resistances",
      sr_setups_hot: "{n} high-probability setup{s} detected",
      range: "↕ Range",
      range_title: "Trading range: high/low of visible candles (adjusts to brush)",
      trendline: "📈 Trendline",
      trendline_title: "Trendline: connects recent pivots and projects it",
      patterns: "◆ Patterns",
      patterns_title: "Chart patterns: Double Top/Bottom, Triangles and H&S (per-coin calibration)",
      candles: "🕯 Candles",
      candles_title: "Candle patterns: Hammer, Hanging Man, Inv. Hammer, Shooting Star, Doji, Engulfing",
      ema: "📈 EMA",
      ema_title: "EMAs 9/21/50/200 with crossover detection (Golden/Death, 21×50, 9×21). Relevance depends on timeframe.",
      structure_default: "Structure",
      historical: "📜 Historical",
      historical_title: "Historical setups detected and real hit-rate %",
      predictions: "📊 Predictions",
      predictions_title: "Historical AI Cascade Predictor predictions and real hit-rate %",
      timer: "⏱️ Timer",
      timer_title: "Cascade Timer historical (countdown vs real time)",
      stochastic: "📊 Stochastic",
      stochastic_title: "Stochastic Oscillator (K=14, D=3, Smooth=3) — shows momentum and overbought/oversold zones",
    },
    stochastic: {
      overbought: "OVERBOUGHT",
      oversold: "OVERSOLD",
      neutral: "NEUTRAL",
      signal_bull: "Bullish cross in oversold",
      signal_bear: "Bearish cross in overbought",
    },
    composite: {
      title: "Composite Signal",
      verdicts: {
        STRONG_BUY: "STRONG BUY",
        BUY: "BUY",
        NEUTRAL: "NEUTRAL",
        SELL: "SELL",
        STRONG_SELL: "STRONG SELL",
      },
      presets: { conservador: "Cons", balanceado: "Bal", agresivo: "Agg" },
      preset_titles: {
        conservador: "Conservative — weights EMA and Wyckoff (slow signals)",
        balanceado: "Balanced — even mix across all indicators",
        agresivo: "Aggressive — weights Stochastic and Cascade (fast mean-reversion)",
      },
      custom_short: "CUST",
      custom_title: "Configure custom weights",
      custom_locked: "Customization available in RE₿EL PRO",
      delayed: "DELAYED 5 MIN",
      breakdown_title: "Active contributors",
      no_signals: "No active signals — enable chart toggles",
      disclaimer: "Composite score of active indicators. Not financial advice.",
      contrib: {
        ema: "EMA cross",
        stochastic: "Stochastic cross",
        cluster: "Cluster proximity",
        wyckoff: "Wyckoff structure",
        cascade: "Cascade predictor",
      },
    },
    sr_top: {
      btn_label: "🏆 Top S/R",
      btn_title: "Cross-coin top S/R levels ranked by composite strength score",
      panel_title: "Top S/R levels",
      panel_subtitle: "Cross-coin ranking by composite strength score",
      tf_label: "Timeframe",
      limit_label: "Top",
      coin_filter_label: "Coin",
      coin_all: "ALL",
      empty: "No levels available for this timeframe.",
      empty_coin: "No levels available for {coin} in this timeframe.",
      loading: "Loading ranking…",
      err: "Could not load the ranking. Retrying…",
      col_rank: "#",
      col_coin: "Coin",
      col_kind: "Kind",
      col_price: "Price",
      col_score: "Score",
      col_tasa: "Success",
      col_toques: "Touches",
      col_dist: "Distance",
      kind_R: "Resistance",
      kind_S: "Support",
      tier_fuerte: "STRONG",
      tier_media: "MEDIUM",
      tier_debil: "WEAK",
      footer_hint:
        "The score combines historical success (40%) + touch count (25%) + recency (20%) + proximity to spot (15%). Only real levels — coverage placeholders are excluded.",
    },
    range_tooltip: {
      min_prefix: "MIN seen",
      max_prefix: "MAX seen",
      candle_of: "candle",
      on: "on",
    },
    trend_tooltip: {
      title: "Trendline pivots",
      anchor: "Anchor",
      intermediate: "Intermediate pivot",
      hint_anchor: "The line passes exactly through these points.",
      hint_intermediate: "They validate the direction but don't influence the line.",
      kind_low: "Swing low",
      kind_high: "Swing high",
      total_pivots: "{n} pivots",
      delta_summary: "Δ {pct} · {n} candles",
      empty: "No pivots detected.",
    },
    patterns: {
      label_double_top: "Double Top",
      label_double_bottom: "Double Bottom",
      status_confirmed: "confirmed",
      status_forming: "forming",
      status_invalidated: "invalidated",
      invalidated_badge: "✗ INVALIDATED",
      invalidated_reason_doubletop: "price closed above the peaks",
      invalidated_reason_doublebottom: "price closed below the lows",
      invalidated_reason_hs: "price closed above the head",
      invalidated_reason_inv_hs: "price closed below the head",
      invalidated_reason_triangle_asc: "price broke down (Asc expected upside break)",
      invalidated_reason_triangle_desc: "price broke up (Desc expected downside break)",
      tooltip_invalidation: "Invalidation @ {price}",
      no_pattern: "No pattern detected",
      neckline_at: "Neckline at {price}",
      pending_break: "neckline not broken yet",
      pending_break_triangle: "apex not reached yet",
      triangle_ascending: "Ascending Triangle",
      triangle_descending: "Descending Triangle",
      triangle_symmetric: "Symmetric Triangle",
      tooltip_title_top: "Double Top · {status}",
      tooltip_title_bottom: "Double Bottom · {status}",
      tooltip_peak1: "Peak 1",
      tooltip_peak2: "Peak 2",
      tooltip_valley: "Valley (neckline)",
      tooltip_bottom1: "Bottom 1",
      tooltip_bottom2: "Bottom 2",
      tooltip_ridge: "Ridge (neckline)",
      tooltip_high_pivot: "High pivot",
      tooltip_low_pivot: "Low pivot",
      tooltip_neckline: "Neckline",
      tooltip_break: "Break",
      tooltip_calibrated: "Tolerance {coin}: ±{tol}%",
      tooltip_fallback: "Pooled tolerance: ±{tol}% ({coin} not calibrated)",
      tooltip_triangle_flat: "Flat {coin}: ≤{flat}%/candle",
      tooltip_triangle_flat_pooled: "Pooled flat: ≤{flat}%/candle ({coin} not calibrated)",
      // ── Head & Shoulders ─────────────────────────────────────────
      label_hs: "Head & Shoulders",
      label_inv_hs: "Inverse H&S",
      tooltip_ls: "Left Shoulder",
      tooltip_head: "Head",
      tooltip_rs: "Right Shoulder",
      tooltip_neckline_diag: "Neckline (diagonal)",
      tooltip_head_diff: "Head vs shoulders Δ",
      tooltip_shoulder_diff: "Shoulder Δ",
      tooltip_hch_calibrated: "Head ≥ {head}% · Shoulder Δ ≤ {shoulder}% ({coin})",
      tooltip_hch_pooled: "Head ≥ {head}% · Shoulder Δ ≤ {shoulder}% (pooled, {coin} not calibrated)",
      // ── Candlestick patterns ─────────────────────────────────────
      candle_hammer: "Hammer",
      candle_hanging_man: "Hanging Man",
      candle_inverted_hammer: "Inverted Hammer",
      candle_shooting_star: "Shooting Star",
      candle_doji: "Doji",
      candle_engulfing_bull: "Bullish Engulfing",
      candle_engulfing_bear: "Bearish Engulfing",
      candle_signal_bullish: "bullish",
      candle_signal_bearish: "bearish",
      candle_signal_neutral: "neutral",
      candle_body_ratio: "Body / range",
      candle_engulf_ratio: "Engulf ratio",
      candle_lower_wick: "Lower wick",
      candle_upper_wick: "Upper wick",
      candle_drift: "Drift (ctx)",
      candle_no_pattern: "No candle pattern",
      // ── Mini legend (DOM, left-edge collapsible) ────────────────
      candle_legend_title: "Candles",
      candle_legend_doji: "Doji",
      candle_legend_hammer: "Hammer · Hanging Man",
      candle_legend_inv_hammer: "Inv. Hammer · Shooting Star",
      candle_legend_engulfing: "Engulfing",
      candle_legend_cluster: "Cluster (N nearby candles)",
      candle_legend_collapse: "Collapse legend",
      candle_legend_expand: "Expand legend",
      candle_legend_count: "{n} pattern(s) in range",
      // ── Manual drawing tools (Fase B1) ──────────────────────────
      drawing: {
        toggle_title: "Manual drawing tools",
        toggle_label: "Draw",
        tool_cursor: "Cursor (pan/zoom)",
        tool_line: "Trendline",
        tool_horizontal: "Horizontal line",
        tool_vertical: "Vertical line",
        tool_rect: "Rectangle",
        tool_text: "Text",
        tool_eraser: "Erase",
        tool_magnet: "Magnet: snap to candle (OHLC)",
        tool_measure: "Measure (transient)",
        tool_fib_ret: "Fibonacci Retracement",
        tool_fib_ext: "Fibonacci Extension",
        tool_channel: "Parallel Channel (3 clicks)",
        tool_position: "Long/Short Position (3 clicks)",
        tool_circle: "Circle",
        tool_ellipse: "Ellipse",
        tool_triangle: "Triangle (3 clicks)",
        tool_freehand: "Freehand brush",
        tool_polyline: "Polyline (dbl-click/Enter)",
        tool_callout: "Callout (arrow + text)",
        tool_flag: "Flag / Signpost",
        tool_fib_timezone: "Fib Time Zone",
        tool_fib_speedfan: "Fib Speed Resistance Fan",
        tool_fib_wedge: "Fib Wedge",
        tool_xabcd: "XABCD (5 clicks)",
        tool_cypher: "Cypher (5 clicks)",
        tool_three_drives: "Three Drives (3 clicks)",
        tool_elliott_imp: "Elliott Impulse (5 clicks)",
        tool_elliott_corr: "Elliott Correction (3 clicks)",
        tool_gann_fan: "Gann Fan (2 anchors)",
        tool_gann_box: "Gann Box (2 anchors)",
        // Fase B5a — new tools (12)
        tool_highlighter: "Highlighter",
        tool_pitchfork: "Andrews' Pitchfork (3 clicks)",
        tool_fib_channel: "Fib Channel",
        tool_fib_ext_trend: "Trend-based Fib Extension (3 clicks)",
        tool_forecast: "Forecast / Projection",
        tool_price_range: "Measure range (price)",
        tool_date_range: "Measure range (date)",
        tool_date_price_range: "Measure range (date + price)",
        tool_abcd: "Manual ABCD (4 clicks)",
        tool_head_shoulders: "Head & Shoulders (7 clicks)",
        tool_triangle_pattern: "Triangle (chartist, 4 clicks)",
        tool_cycle_lines: "Cycle lines",
        tool_bars_pattern: "Bars pattern (capture + reposition)",
        // Fase B6 — professional gaps
        tool_ray: "Ray (infinite line in one direction)",
        tool_horizontal_ray: "Horizontal ray (rightward only)",
        tool_vertical_ray: "Vertical ray (upward only)",
        tool_flag_chartist: "Flag / Pennant / Wedge chartist (4 clicks)",
        tool_schiff_pitchfork: "Schiff Pitchfork (3 clicks)",
        tool_modified_schiff_pitchfork: "Modified Schiff Pitchfork (3 clicks)",
        tool_cup_handle: "Cup & Handle (5 clicks)",
        tool_share: "Share drawings as a link",
        share_empty: "No drawings to share",
        share_copied: "Permalink copied ({n} drawings · {kb} KB)",
        share_imported: "{n} drawings imported",
        share_fallback: "Copy this link:",
        // Toolbar groups
        group_lineas: "Lines",
        group_fib: "Fibonacci & Gann",
        group_patrones: "Patterns",
        group_prediccion: "Forecast & measure",
        group_formas: "Shapes",
        group_anotacion: "Annotation",
        toggle_persistent: "Persistent drawing mode",
        toggle_lock_all: "Lock all drawings",
        toggle_hide_all: "Hide all drawings",
        ctx_lock: "Lock",
        ctx_unlock: "Unlock",
        ctx_hide: "Hide",
        ctx_show: "Show",
        ctx_clone: "Clone",
        ctx_delete: "Delete",
        ctx_color: "Color",
        ctx_width: "Width",
        ctx_width_thin: "Thin",
        ctx_width_normal: "Normal",
        ctx_width_thick: "Thick",
        ctx_width_bold: "Bold",
        ctx_color_custom: "Custom",
        ctx_width_locked_tooltip: "Fixed to preserve the highlighter effect",
        ctx_apply_to_type: "Apply style to all ({n})",
        undo_empty: "No more steps to undo",
        redo_empty: "No more steps to redo",
        prompt_flag: "Flag label:",
        prompt_callout: "Callout text:",
        tool_clear_all: "Clear all drawings",
        prompt_text: "Text:",
        confirm_clear_all: "Clear all drawings on this view?",
      },
    },
  },
  sk: {
    title: "Liquidity Map",
    subtitle: "Agregovaná mapa likvidácií · 12 exchanges",
    live: "NAŽIVO",
    exchanges: "exchanges",
    loading: "Načítavam…",
    guest_title: "Potrebuješ účet zdarma",
    guest_sub: "Liquidity Map zobrazuje real-time cluster likvidácií agregované z 12 exchange. Vytvor si účet zdarma za 30 sekúnd a získaj plný trial.",
    guest_cta_register: "Vytvoriť účet zdarma",
    guest_cta_login: "Už mám účet",
    err_insufficient: "Momentálne nedostatočné dáta. Opakujem pokus…",
    err_load: "Nepodarilo sa načítať dáta. Opakujem pokus…",
    coins: {
      BTC: "Bitcoin",
      ETH: "Ethereum",
      SOL: "Solana",
      BNB: "BNB",
      XRP: "XRP",
      ZEC: "Zcash",
    },
    stats: {
      price: "Cena",
      change24: "24h%",
      oi: "Open Interest",
      liq_longs: "EXPOZÍCIA LIQ LONGS",
      liq_shorts: "EXPOZÍCIA LIQ SHORTS",
      liq_longs_tooltip: "Odhadovaná expozícia likvidáciám na základe OI a hustoty clusterov. Reálne likvidácie v reálnom čase: čoskoro.",
      liq_shorts_tooltip: "Odhadovaná expozícia likvidáciám na základe OI a hustoty clusterov. Reálne likvidácie v reálnom čase: čoskoro.",
      liq_longs_real: "LIQ LONGS 24H",
      liq_shorts_real: "LIQ SHORTS 24H",
      liq_real_tooltip: "Reálne agregované likvidácie z OKX, Bitget a Hyperliquid za posledných 24h. Vylučuje Binance/Bybit (geografické obmedzenie).",
      liq_real_badge_live: "NAŽIVO · OKX/BG/HL",
      liq_real_badge_partial: "ČIASTOČNÉ · {n}/3 zdroje",
      liq_real_badge_degraded: "DEGRADOVANÉ · 1/3 zdroj",
      liq_real_badge_offline: "OFFLINE · žiadny feed",
      liq_real_badge_warming: "WARMING UP · {m}m zostáva",
      liq_real_partial_hl_note: "Hyperliquid nellistuje túto menu.",
      cluster_max: "Cluster max",
    },
    wyckoff: {
      title_overline: "ANALÝZA",
      title: "Štruktúra trhu",
      open_btn_label: "📐 Štruktúra",
      open_btn_title: "Zobraziť analýzu štruktúry trhu (rozsah, udalosti, kontext)",
      loading: "Načítavam analýzu…",
      error: "Nepodarilo sa načítať analýzu. Opakujem pokus…",
      range_section_title: "Aktívny rozsah",
      ranging_yes: "✓ Áno",
      ranging_no: "— Nezistené",
      confidence: "Spoľahlivosť",
      range_high: "Strop",
      range_low: "Dno",
      midpoint: "Stred",
      range_pct: "Šírka",
      window_label: "Okno",
      duration_label: "Trvanie v rozsahu",
      duration_tier_extended: "rozšírená konsolidácia",
      duration_tier_major: "väčšia kompresia",
      candles_unit: "sviečky",
      no_range_hint: "Cena neukazuje jasný rozsah v tomto timeframe. Skúste širší (4h, 1d).",
      events_section_title: "Zistené udalosti",
      no_events: "Žiadne relevantné udalosti v tomto timeframe.",
      spring_label: "Možný Spring",
      utad_label: "Možné UTAD",
      sc_label: "Možný Selling Climax",
      bc_label: "Možný Buying Climax",
      cluster_at: "Cluster",
      conviction_high: "vysoká presvedčenosť",
      conviction_medium: "stredná presvedčenosť",
      conviction_low: "nízka presvedčenosť",
      conviction_unknown: "presvedčenosť ND",
      cluster_section_title: "Kontext clusterov",
      cluster_max: "Hlavný",
      cluster_second: "Sekundárny",
      cluster_hint: "Clustery likvidácií sú Creek/Ice rozsahu Wyckoff — zóny, kde sa štruktúra môže prelomiť alebo udržať.",
      badge_ranging: "📐 ROZSAH AKTÍVNY · {tf}",
      badge_no_range: "📐 ŠTRUKTÚRA · {tf}",
      share_to_shadow: "Zdieľať do Shadow",
      share_capture_failed: "Nepodarilo sa zachytiť analýzu",
    },
    trial: {
      days_left_one: "1 deň zostáva",
      days_left_many: "{n} dní zostáva",
      expired_title: "Vaša bezplatná skúšobná verzia skončila",
      expired_strong: "bezplatná skúšobná verzia",
      expired_sub: "Odomknite Liquidity Map s reálnymi dátami z 12 exchanges.",
      cta_lifetime: "Získať doživotný PRO prístup →",
      cta_rbl: "Zaplatiť s R₿L on-chain -50%",
      cta_back: "Späť na domov",
      lifetime_note: "⏳ Doživotná ponuka dostupná do 2. augusta 2026",
      pro_active: "PRO AKTÍVNE",
    },
    cascade: {
      source_label: "zdroj",
      predictor_ia_label: "Predictor IA",
      cascade_timer_label: "Cascade Timer",
      info_aria: "Ako sa vypočíta tento zdroj",
      predictor_ia_info: "Odhad generovaný AI (Claude) z kontextu trhu v reálnom čase: cena, cluster, vzdialenosť, funding, nedávne likvidácie. Je to kvalitatívna analýza, nie fixný vzorec. Overuje sa následne voči reálnej cene (touch-then-bounce).",
      cascade_timer_info: "Odhad vypočítaný kvantitatívnym vzorcom: historická rýchlosť ceny smerom ku clusteru, funding rate, pomer likvidácií longs/shorts, upravený validovanou kvalitou clustera. Overuje sa následne voči reálnej cene (touch-then-bounce).",
      analysis_low_score: "Nízke riziko — podrobná AI analýza sa aktivuje od score 31/100.",
      coverage_disclaimer: "Pokrytie je väčšie pri menách, ktoré najčastejšie navštevujete — prechádzajte záložky na rozšírenie histórie ostatných.",
      monitoring_sr: "Monitorujem — zatiaľ bez potvrdeného setupu",
      monitoring_predictor: "Monitorujem — zatiaľ bez potvrdenej predikcie",
      risk_imminent: "BLÍŽIACA SA KASKÁDA",
      risk_high: "VYSOKÉ RIZIKO",
      risk_moderate: "STREDNÉ RIZIKO",
      risk_low: "NÍZKE RIZIKO",
      label_price: "Cena",
      label_cluster: "Cluster",
      label_distance: "Vzdialenosť",
      analyzing_ai: "Analyzujem s RE₿EL AI...",
      updated_ago: "Aktualizované pred {n}s",
      cache_active: "Cache aktívna",
      local_analysis: "lokálna analýza",
      history_btn: "História",
      history_btn_title: "Otvorí panel 'Nedávne predikcie' (overené touch-then-bounce) filtrované na aktuálnu menu.",
      zone_critical: "⚡ KRITICKÁ ZÓNA",
      estimated_cascade: "⏱️ ODHADOVANÁ KASKÁDA",
      pressure_relieved: "⏸ TLAK UVOĽNENÝ — cena sa vzďaľuje od clustera",
      cluster_reached: "⚡ CLUSTER DOSIAHNUTÝ — KASKÁDA SPUSTENÁ",
      probability: "PRAVDEPODOBNOSŤ",
      validated_footer: "Overené: {venues} venues · {pct}% reálnych likvidácií",
      trend_lateral: "BOČNÝ",
      trend_bullish: "BÝČÍ",
      trend_bearish: "MEDVEDÍ",
      history_title: "HISTÓRIA KASKÁD",
      history_empty: "Žiadne záznamy pre {coin}",
      history_close_aria: "Zavrieť históriu",
      banner_close_aria: "Zavrieť banner",
    },
    toolbar: {
      whales: "🐋 Veľryby",
      whales_title: "Zobraziť/skryť veľryby (>$1M) a stredné objednávky ($100K+)",
      sr_ai: "📐 S/R AI",
      sr_ai_title: "Podpory a rezistencie detegované AI",
      sr_setups_hot: "{n} setup{s} s vysokou pravdepodobnosťou detegovaný{s}",
      range: "↕ Rozsah",
      range_title: "Obchodný rozsah: max/min viditeľných sviec (prispôsobuje sa brush)",
      trendline: "📈 Trend",
      trendline_title: "Trendová línia: spája nedávne piloty a projektuje ju",
      patterns: "◆ Vzory",
      patterns_title: "Grafické vzory: Double Top/Bottom, Trojuholníky a HCH (kalibrácia per-coin)",
      candles: "🕯 Sviečky",
      candles_title: "Sviečkové vzory: Hammer, Hanging Man, Inv. Hammer, Shooting Star, Doji, Engulfing",
      ema: "📈 EMA",
      ema_title: "EMAs 9/21/50/200 s detekciou krížení (Golden/Death, 21×50, 9×21). Relevantnosť závisí od timeframe.",
      structure_default: "Štruktúra",
      historical: "📜 História",
      historical_title: "História detegovaných setupov a ich % skutočnej úspešnosti",
      predictions: "📊 Predikcie",
      predictions_title: "História predikcií Cascade Predictor AI a ich % skutočnej úspešnosti",
      timer: "⏱️ Timer",
      timer_title: "História Cascade Timer (countdown vs reálny čas)",
      stochastic: "📊 Stochastický",
      stochastic_title: "Stochastický oscilátor (K=14, D=3, Smooth=3) — zobrazuje momentum a zóny prekúpenia/prepredaja",
    },
    stochastic: {
      overbought: "PREKÚPENÉ",
      oversold: "PREPREDANÉ",
      neutral: "NEUTRÁLNE",
      signal_bull: "Býčí kríž v prepredanej zóne",
      signal_bear: "Medvedí kríž v prekúpenej zóne",
    },
    composite: {
      title: "Kompozitný signál",
      verdicts: {
        STRONG_BUY: "SILNÝ NÁKUP",
        BUY: "NÁKUP",
        NEUTRAL: "NEUTRÁL",
        SELL: "PREDAJ",
        STRONG_SELL: "SILNÝ PREDAJ",
      },
      presets: { conservador: "Kons", balanceado: "Bal", agresivo: "Agr" },
      preset_titles: {
        conservador: "Konzervatívny — váži EMA a Wyckoff (pomalé signály)",
        balanceado: "Vyvážený — rovnomerný mix všetkých indikátorov",
        agresivo: "Agresívny — váži Stochastik a Cascade (rýchla mean-reversion)",
      },
      custom_short: "VLAST",
      custom_title: "Nastav vlastné váhy",
      custom_locked: "Personalizácia dostupná v RE₿EL PRO",
      delayed: "ONESKORENÉ 5 MIN",
      breakdown_title: "Aktívne príspevky",
      no_signals: "Žiadne aktívne signály — zapni prepínače chartu",
      disclaimer: "Kompozitné skóre aktívnych indikátorov. Nie je to finančné poradenstvo.",
      contrib: {
        ema: "EMA kríž",
        stochastic: "Stochastický kríž",
        cluster: "Blízkosť clustera",
        wyckoff: "Wyckoff štruktúra",
        cascade: "Predictor kaskády",
      },
    },
    sr_top: {
      btn_label: "🏆 Top S/R",
      btn_title: "Top úrovne S/R cross-coin zoradené podľa score sily",
      panel_title: "Top úrovne S/R",
      panel_subtitle: "Ranking cross-coin podľa kompozitného score sily",
      tf_label: "Timeframe",
      limit_label: "Top",
      coin_filter_label: "Mena",
      coin_all: "VŠETKY",
      empty: "Žiadne dostupné úrovne v tomto timeframe.",
      empty_coin: "Žiadne úrovne pre {coin} v tomto timeframe.",
      loading: "Načítavam ranking…",
      err: "Nepodarilo sa načítať ranking. Opakujem pokus…",
      col_rank: "#",
      col_coin: "Mena",
      col_kind: "Typ",
      col_price: "Cena",
      col_score: "Score",
      col_tasa: "Úspech",
      col_toques: "Dotyky",
      col_dist: "Vzdialenosť",
      kind_R: "Rezistencia",
      kind_S: "Podpora",
      tier_fuerte: "SILNÁ",
      tier_media: "STREDNÁ",
      tier_debil: "SLABÁ",
      footer_hint: "Score kombinuje historický úspech (40%) + počet dotykov (25%) + recentnosť (20%) + blízkosť (15%). Len reálne úrovne — placeholdery pokrytia nevstupujú do rankingu.",
    },
    range_tooltip: {
      min_prefix: "MIN videné",
      max_prefix: "MAX videné",
      candle_of: "sviečka z",
      on: "dňa",
    },
    trend_tooltip: {
      title: "Pivoty trendu",
      anchor: "Kotva",
      intermediate: "Pivot medzistupeň",
      hint_anchor: "Čiara prechádza presne týmito bodmi.",
      hint_intermediate: "Validujú smer, ale neovplyvňujú čiaru.",
      kind_low: "Minimum (swing low)",
      kind_high: "Maximum (swing high)",
      total_pivots: "{n} pivotov",
      delta_summary: "Δ {pct} · {n} sviečok",
      empty: "Žiadne pivoty zistené.",
    },
    patterns: {
      label_double_top: "Dvojitý vrchol",
      label_double_bottom: "Dvojité dno",
      status_confirmed: "potvrdené",
      status_forming: "formuje sa",
      status_invalidated: "invalidované",
      invalidated_badge: "✗ INVALIDOVANÉ",
      invalidated_reason_doubletop: "cena zatvorila nad vrcholmi",
      invalidated_reason_doublebottom: "cena zatvorila pod minimami",
      invalidated_reason_hs: "cena zatvorila nad hlavou",
      invalidated_reason_inv_hs: "cena zatvorila pod hlavou",
      invalidated_reason_triangle_asc: "cena prelomila nadol (Asc očakával býčí prelom)",
      invalidated_reason_triangle_desc: "cena prelomila nahor (Desc očakával medvedí prelom)",
      tooltip_invalidation: "Invalidácia @ {price}",
      no_pattern: "Žiadny zistený vzor",
      neckline_at: "Neckline na {price}",
      pending_break: "chýba prelomiť neckline",
      pending_break_triangle: "vrchol čakajúci",
      triangle_ascending: "Vzostupný trojuholník",
      triangle_descending: "Zostupný trojuholník",
      triangle_symmetric: "Symetrický trojuholník",
      tooltip_title_top: "Dvojitý vrchol · {status}",
      tooltip_title_bottom: "Dvojité dno · {status}",
      tooltip_peak1: "Vrchol 1",
      tooltip_peak2: "Vrchol 2",
      tooltip_valley: "Dolina (neckline)",
      tooltip_bottom1: "Minimum 1",
      tooltip_bottom2: "Minimum 2",
      tooltip_ridge: "Hrebeň (neckline)",
      tooltip_high_pivot: "Pivot hore",
      tooltip_low_pivot: "Pivot dole",
      tooltip_neckline: "Neckline",
      tooltip_break: "Prelom",
      tooltip_calibrated: "Tolerancia {coin}: ±{tol}%",
      tooltip_fallback: "Tolerancia pooled: ±{tol}% ({coin} nekalibrované)",
      tooltip_triangle_flat: "Flat {coin}: ≤{flat}%/sviečka",
      tooltip_triangle_flat_pooled: "Flat pooled: ≤{flat}%/sviečka ({coin} nekalibrované)",
      label_hs: "Rameno-Hlava-Rameno",
      label_inv_hs: "HCH Invertované",
      tooltip_ls: "Ľavé rameno",
      tooltip_head: "Hlava",
      tooltip_rs: "Pravé rameno",
      tooltip_neckline_diag: "Neckline (diagonálna)",
      tooltip_head_diff: "Δ hlava-ramená",
      tooltip_shoulder_diff: "Δ medzi ramenami",
      tooltip_hch_calibrated: "Hlava ≥ {head}% · Δ ramená ≤ {shoulder}% ({coin})",
      tooltip_hch_pooled: "Hlava ≥ {head}% · Δ ramená ≤ {shoulder}% (pooled, {coin} nekalibrované)",
      candle_hammer: "Hammer",
      candle_hanging_man: "Hanging Man",
      candle_inverted_hammer: "Inverted Hammer",
      candle_shooting_star: "Shooting Star",
      candle_doji: "Doji",
      candle_engulfing_bull: "Engulfing Býčí",
      candle_engulfing_bear: "Engulfing Medvedí",
      candle_signal_bullish: "býčí",
      candle_signal_bearish: "medvedí",
      candle_signal_neutral: "neutrálny",
      candle_body_ratio: "Telo / rozsah",
      candle_engulf_ratio: "Pomer engulf",
      candle_lower_wick: "Spodný knôt",
      candle_upper_wick: "Horný knôt",
      candle_drift: "Drift (ctx)",
      candle_no_pattern: "Žiadny vzor sviečky",
      candle_legend_title: "Sviečky",
      candle_legend_doji: "Doji",
      candle_legend_hammer: "Hammer · Hanging Man",
      candle_legend_inv_hammer: "Inv. Hammer · Shooting Star",
      candle_legend_engulfing: "Engulfing",
      candle_legend_cluster: "Zhluk (N blízkych sviečok)",
      candle_legend_collapse: "Zbaliť legendu",
      candle_legend_expand: "Rozbaliť legendu",
      candle_legend_count: "{n} vzor(ov) v rozsahu",
      drawing: {
        toggle_title: "Nástroje manuálneho kreslenia",
        toggle_label: "Kresliť",
        tool_cursor: "Kurzor (pan/zoom)",
        tool_line: "Trendová čiara",
        tool_horizontal: "Horizontálna čiara",
        tool_vertical: "Vertikálna čiara",
        tool_rect: "Obdĺžnik",
        tool_text: "Text",
        tool_eraser: "Vymazať",
        tool_magnet: "Magnet: prispôsobiť sviečke (OHLC)",
        tool_measure: "Merač (prechodný)",
        tool_fib_ret: "Fibonacci Retracement",
        tool_fib_ext: "Fibonacci Extension",
        tool_channel: "Paralelný kanál (3 kliky)",
        tool_position: "Pozícia Long/Short (3 kliky)",
        tool_circle: "Kruh",
        tool_ellipse: "Elipsa",
        tool_triangle: "Trojuholník (3 kliky)",
        tool_freehand: "Voľné kreslenie",
        tool_polyline: "Polylínia (dbl-click/Enter)",
        tool_callout: "Callout (šípka + text)",
        tool_flag: "Flag / Signpost",
        tool_fib_timezone: "Fib Time Zone",
        tool_fib_speedfan: "Fib Speed Resistance Fan",
        tool_fib_wedge: "Fib Wedge",
        tool_xabcd: "XABCD (5 klikov)",
        tool_cypher: "Cypher (5 klikov)",
        tool_three_drives: "Three Drives (3 kliky)",
        tool_elliott_imp: "Elliott Impulz (5 klikov)",
        tool_elliott_corr: "Elliott Korekcia (3 kliky)",
        tool_gann_fan: "Gann Fan (2 kotvy)",
        tool_gann_box: "Gann Box (2 kotvy)",
        tool_highlighter: "Zvýrazňovač",
        tool_pitchfork: "Pitchfork Andrewsov (3 kliky)",
        tool_fib_channel: "Fib Channel",
        tool_fib_ext_trend: "Fib Extension podľa trendu (3 kliky)",
        tool_forecast: "Forecast / Projekcia",
        tool_price_range: "Merať rozsah (cena)",
        tool_date_range: "Merať rozsah (dátum)",
        tool_date_price_range: "Merať rozsah (dátum + cena)",
        tool_abcd: "ABCD manuálne (4 kliky)",
        tool_head_shoulders: "Hlava a ramená (7 klikov)",
        tool_triangle_pattern: "Trojuholník (chartist, 4 kliky)",
        tool_cycle_lines: "Cyklické čiary",
        tool_bars_pattern: "Vzor stĺpcov (zachytiť + presunúť)",
        tool_ray: "Ray (nekonečná čiara jedným smerom)",
        tool_horizontal_ray: "Horizontal ray (len vpravo)",
        tool_vertical_ray: "Vertical ray (len nahor)",
        tool_flag_chartist: "Flag / Pennant / Wedge chartist (4 kliky)",
        tool_schiff_pitchfork: "Schiff Pitchfork (3 kliky)",
        tool_modified_schiff_pitchfork: "Modified Schiff Pitchfork (3 kliky)",
        tool_cup_handle: "Cup & Handle (5 klikov)",
        tool_share: "Zdieľať kresby ako odkaz",
        share_empty: "Žiadne kresby na zdieľanie",
        share_copied: "Permalink skopírovaný ({n} kresieb · {kb} KB)",
        share_imported: "{n} kresieb importovaných",
        share_fallback: "Skopírujte tento odkaz:",
        group_lineas: "Čiary",
        group_fib: "Fibonacci a Gann",
        group_patrones: "Vzory",
        group_prediccion: "Predikcia a meranie",
        group_formas: "Tvary",
        group_anotacion: "Anotácia",
        toggle_persistent: "Perzistentný režim kreslenia",
        toggle_lock_all: "Zamknúť všetky kresby",
        toggle_hide_all: "Skryť všetky kresby",
        ctx_lock: "Zamknúť",
        ctx_unlock: "Odomknúť",
        ctx_hide: "Skryť",
        ctx_show: "Zobraziť",
        ctx_clone: "Klonovať",
        ctx_delete: "Odstrániť",
        ctx_color: "Farba",
        ctx_width: "Hrúbka",
        ctx_width_thin: "Tenká",
        ctx_width_normal: "Normálna",
        ctx_width_thick: "Hrubá",
        ctx_width_bold: "Bold",
        ctx_color_custom: "Vlastná",
        ctx_width_locked_tooltip: "Fixné na udržanie efektu zvýrazňovača",
        ctx_apply_to_type: "Aplikovať štýl na všetky ({n})",
        undo_empty: "Nie sú ďalšie kroky na vrátenie",
        redo_empty: "Nie sú ďalšie kroky na zopakovanie",
        prompt_flag: "Označenie flagu:",
        prompt_callout: "Text calloutu:",
        tool_clear_all: "Vymazať všetky kresby",
        prompt_text: "Text:",
        confirm_clear_all: "Vymazať všetky kresby v tomto pohľade?",
      },
    },
  },
  de: {
    title: "Liquiditätskarte",
    subtitle: "Aggregierte Liquidationskarte · 12 exchanges",
    live: "LIVE",
    exchanges: "exchanges",
    loading: "Lädt…",
    guest_title: "Du brauchst ein kostenloses Konto",
    guest_sub: "Liquidity Map zeigt Echtzeit-Liquidations-Cluster aggregiert aus 12 Exchanges. Erstelle dein kostenloses Konto in 30 Sekunden und erhalte vollen Trial-Zugang.",
    guest_cta_register: "Kostenloses Konto erstellen",
    guest_cta_login: "Ich habe bereits ein Konto",
    err_insufficient: "Derzeit unzureichende Daten. Wiederholung…",
    err_load: "Daten konnten nicht geladen werden. Wiederholung…",
    coins: {
      BTC: "Bitcoin",
      ETH: "Ethereum",
      SOL: "Solana",
      BNB: "BNB",
      XRP: "XRP",
      ZEC: "Zcash",
    },
    stats: {
      price: "Preis",
      change24: "24h%",
      oi: "Open Interest",
      liq_longs: "LIQ-EXPOSURE LONGS",
      liq_shorts: "LIQ-EXPOSURE SHORTS",
      liq_longs_tooltip: "Geschätzte Liquidations-Exposure basierend auf OI und Cluster-Dichte. Echtzeit-Liquidationen: demnächst verfügbar.",
      liq_shorts_tooltip: "Geschätzte Liquidations-Exposure basierend auf OI und Cluster-Dichte. Echtzeit-Liquidationen: demnächst verfügbar.",
      liq_longs_real: "LIQ LONGS 24H",
      liq_shorts_real: "LIQ SHORTS 24H",
      liq_real_tooltip: "Aggregierte echte Liquidationen von OKX, Bitget und Hyperliquid der letzten 24h. Ohne Binance/Bybit (geografische Beschränkung).",
      liq_real_badge_live: "LIVE · OKX/BG/HL",
      liq_real_badge_partial: "PARTIELL · {n}/3 Quellen",
      liq_real_badge_degraded: "DEGRADIERT · 1/3 Quelle",
      liq_real_badge_offline: "OFFLINE · kein Feed",
      liq_real_badge_warming: "WARMING UP · {m}m verbleibend",
      liq_real_partial_hl_note: "Hyperliquid listet diesen Coin nicht.",
      cluster_max: "Max. Cluster",
    },
    wyckoff: {
      title_overline: "ANALYSE",
      title: "Marktstruktur",
      open_btn_label: "📐 Struktur",
      open_btn_title: "Marktstrukturanalyse anzeigen (Range, Events, Kontext)",
      loading: "Analyse wird geladen…",
      error: "Analyse konnte nicht geladen werden. Wiederholung…",
      range_section_title: "Aktive Range",
      ranging_yes: "✓ Ja",
      ranging_no: "— Nicht erkannt",
      confidence: "Konfidenz",
      range_high: "Decke",
      range_low: "Boden",
      midpoint: "Mitte",
      range_pct: "Breite",
      window_label: "Fenster",
      duration_label: "Dauer in Range",
      duration_tier_extended: "erweiterte Konsolidierung",
      duration_tier_major: "größere Kompression",
      candles_unit: "Kerzen",
      no_range_hint: "Der Preis zeigt in diesem Timeframe keine klare Range. Versuche einen breiteren Timeframe (4h, 1d).",
      events_section_title: "Erkannte Events",
      no_events: "Keine relevanten Events in diesem Timeframe.",
      spring_label: "Möglicher Spring",
      utad_label: "Möglicher UTAD",
      sc_label: "Möglicher Selling Climax",
      bc_label: "Möglicher Buying Climax",
      cluster_at: "Cluster",
      conviction_high: "hohe Conviction",
      conviction_medium: "mittlere Conviction",
      conviction_low: "niedrige Conviction",
      conviction_unknown: "Conviction n. v.",
      cluster_section_title: "Cluster-Kontext",
      cluster_max: "Haupt",
      cluster_second: "Sekundär",
      cluster_hint: "Liquidations-Cluster sind die Creek/Ice der Wyckoff-Range — Zonen, in denen die Struktur brechen oder halten kann.",
      badge_ranging: "📐 RANGE AKTIV · {tf}",
      badge_no_range: "📐 STRUKTUR · {tf}",
      share_to_shadow: "Auf Shadow teilen",
      share_capture_failed: "Analyse konnte nicht erfasst werden",
    },
    trial: {
      days_left_one: "1 Tag verbleibend",
      days_left_many: "{n} Tage verbleibend",
      expired_title: "Deine kostenlose Testversion ist abgelaufen",
      expired_strong: "kostenlose Testversion",
      expired_sub: "Schalte die Liquiditätskarte mit echten Daten von 12 exchanges frei.",
      cta_lifetime: "Lifetime PRO-Zugang erhalten →",
      cta_rbl: "Mit R₿L on-chain zahlen -50%",
      cta_back: "Zurück zur Startseite",
      lifetime_note: "⏳ Lifetime-Angebot verfügbar bis 2. August 2026",
      pro_active: "PRO AKTIV",
    },
    cascade: {
      source_label: "Quelle",
      predictor_ia_label: "KI-Predictor",
      cascade_timer_label: "Cascade Timer",
      info_aria: "Wie diese Quelle berechnet wird",
      predictor_ia_info: "KI-generierte Schätzung (Claude) basierend auf Echtzeit-Marktkontext: Preis, Cluster, Distanz, Funding, kürzliche Liquidationen. Qualitative Analyse, keine feste Formel. Wird nachträglich gegen den tatsächlichen Preis verifiziert (touch-then-bounce).",
      cascade_timer_info: "Schätzung berechnet mit quantitativer Formel: historische Preisgeschwindigkeit zum Cluster, Funding-Rate, Longs/Shorts-Liquidationsverhältnis, angepasst an die validierte Cluster-Qualität. Wird nachträglich gegen den tatsächlichen Preis verifiziert (touch-then-bounce).",
      analysis_low_score: "Niedriges Risiko — detaillierte KI-Analyse wird ab Score 31/100 aktiviert.",
      coverage_disclaimer: "Die Abdeckung ist höher bei Coins, die du häufiger besuchst — navigiere durch die Tabs, um den Verlauf der anderen zu erweitern.",
      monitoring_sr: "Monitoring — noch kein bestätigtes Setup",
      monitoring_predictor: "Monitoring — noch keine bestätigte Vorhersage",
      risk_imminent: "UNMITTELBARE KASKADE",
      risk_high: "HOHES RISIKO",
      risk_moderate: "MODERATES RISIKO",
      risk_low: "GERINGES RISIKO",
      label_price: "Preis",
      label_cluster: "Cluster",
      label_distance: "Distanz",
      analyzing_ai: "Analyse mit RE₿EL KI...",
      updated_ago: "Vor {n}s aktualisiert",
      cache_active: "Cache aktiv",
      local_analysis: "lokale Analyse",
      history_btn: "Verlauf",
      history_btn_title: "Öffnet das 'Kürzliche Vorhersagen'-Panel (touch-then-bounce verifiziert), gefiltert auf den aktuellen Coin.",
      zone_critical: "⚡ KRITISCHE ZONE",
      estimated_cascade: "⏱️ GESCHÄTZTE KASKADE",
      pressure_relieved: "⏸ DRUCK NACHGELASSEN — Preis entfernt sich vom Cluster",
      cluster_reached: "⚡ CLUSTER ERREICHT — KASKADE GESTARTET",
      probability: "WAHRSCHEINLICHKEIT",
      validated_footer: "Validiert: {venues} Venues · {pct}% echte Liquidationen",
      trend_lateral: "SEITWÄRTS",
      trend_bullish: "BULLISCH",
      trend_bearish: "BÄRISCH",
      history_title: "KASKADEN-VERLAUF",
      history_empty: "Keine Einträge für {coin}",
      history_close_aria: "Verlauf schließen",
      banner_close_aria: "Banner schließen",
    },
    toolbar: {
      whales: "🐋 Wale",
      whales_title: "Wale (>$1M) und mittelgroße Orders ($100K+) ein-/ausblenden",
      sr_ai: "📐 S/R KI",
      sr_ai_title: "KI-erkannte Unterstützungen und Widerstände",
      sr_setups_hot: "{n} hochwahrscheinliches Setup{s} erkannt",
      range: "↕ Bereich",
      range_title: "Handelsspanne: Hoch/Tief der sichtbaren Kerzen (passt sich dem Brush an)",
      trendline: "📈 Trend",
      trendline_title: "Trendlinie: verbindet aktuelle Pivots und projiziert sie",
      patterns: "◆ Muster",
      patterns_title: "Chart-Muster: Doppel-Top/Bottom, Dreiecke und SKS (per-coin-Kalibrierung)",
      candles: "🕯 Kerzen",
      candles_title: "Kerzenmuster: Hammer, Hanging Man, Inv. Hammer, Shooting Star, Doji, Engulfing",
      ema: "📈 EMA",
      ema_title: "EMAs 9/21/50/200 mit Kreuzungserkennung (Golden/Death, 21×50, 9×21). Relevanz hängt vom Timeframe ab.",
      structure_default: "Struktur",
      historical: "📜 Historie",
      historical_title: "Historische erkannte Setups und reale Trefferquote %",
      predictions: "📊 Vorhersagen",
      predictions_title: "Historische Cascade-Predictor-KI-Vorhersagen und reale Trefferquote %",
      timer: "⏱️ Timer",
      timer_title: "Cascade Timer Historie (Countdown vs Echtzeit)",
      stochastic: "📊 Stochastik",
      stochastic_title: "Stochastik-Oszillator (K=14, D=3, Smooth=3) — zeigt Momentum und überkauft/überverkauft-Zonen",
    },
    stochastic: {
      overbought: "ÜBERKAUFT",
      oversold: "ÜBERVERKAUFT",
      neutral: "NEUTRAL",
      signal_bull: "Bullisches Kreuz in überverkauft",
      signal_bear: "Bärisches Kreuz in überkauft",
    },
    composite: {
      title: "Composite-Signal",
      verdicts: {
        STRONG_BUY: "STARKER KAUF",
        BUY: "KAUF",
        NEUTRAL: "NEUTRAL",
        SELL: "VERKAUF",
        STRONG_SELL: "STARKER VERKAUF",
      },
      presets: { conservador: "Kons", balanceado: "Bal", agresivo: "Aggr" },
      preset_titles: {
        conservador: "Konservativ — gewichtet EMA und Wyckoff (langsame Signale)",
        balanceado: "Ausgewogen — gleichmäßiger Mix aller Indikatoren",
        agresivo: "Aggressiv — gewichtet Stochastik und Cascade (schnelle Mean-Reversion)",
      },
      custom_short: "BENUTZ",
      custom_title: "Benutzerdefinierte Gewichte konfigurieren",
      custom_locked: "Personalisierung verfügbar in RE₿EL PRO",
      delayed: "5 MIN VERZÖGERT",
      breakdown_title: "Aktive Beiträger",
      no_signals: "Keine aktiven Signale — aktiviere Chart-Umschalter",
      disclaimer: "Composite-Score aktiver Indikatoren. Keine Anlageberatung.",
      contrib: {
        ema: "EMA-Kreuz",
        stochastic: "Stochastik-Kreuz",
        cluster: "Cluster-Nähe",
        wyckoff: "Wyckoff-Struktur",
        cascade: "Cascade-Predictor",
      },
    },
    sr_top: {
      btn_label: "🏆 Top S/R",
      btn_title: "Top Cross-Coin-S/R-Level nach Stärke-Score sortiert",
      panel_title: "Top S/R-Level",
      panel_subtitle: "Cross-Coin-Ranking nach zusammengesetztem Stärke-Score",
      tf_label: "Timeframe",
      limit_label: "Top",
      coin_filter_label: "Coin",
      coin_all: "ALLE",
      empty: "Keine Level in diesem Timeframe verfügbar.",
      empty_coin: "Keine Level für {coin} in diesem Timeframe.",
      loading: "Ranking wird geladen…",
      err: "Ranking konnte nicht geladen werden. Wiederholung…",
      col_rank: "#",
      col_coin: "Coin",
      col_kind: "Typ",
      col_price: "Preis",
      col_score: "Score",
      col_tasa: "Erfolg",
      col_toques: "Touches",
      col_dist: "Distanz",
      kind_R: "Widerstand",
      kind_S: "Unterstützung",
      tier_fuerte: "STARK",
      tier_media: "MITTEL",
      tier_debil: "SCHWACH",
      footer_hint: "Der Score kombiniert historischen Erfolg (40%) + Anzahl Touches (25%) + Aktualität (20%) + Nähe (15%). Nur echte Level — Coverage-Platzhalter fließen nicht ins Ranking ein.",
    },
    range_tooltip: {
      min_prefix: "MIN gesehen",
      max_prefix: "MAX gesehen",
      candle_of: "Kerze von",
      on: "am",
    },
    trend_tooltip: {
      title: "Trend-Pivots",
      anchor: "Anker",
      intermediate: "Zwischen-Pivot",
      hint_anchor: "Die Linie verläuft exakt durch diese Punkte.",
      hint_intermediate: "Validieren die Richtung, beeinflussen aber nicht die Linie.",
      kind_low: "Tief (Swing Low)",
      kind_high: "Hoch (Swing High)",
      total_pivots: "{n} Pivots",
      delta_summary: "Δ {pct} · {n} Kerzen",
      empty: "Keine Pivots erkannt.",
    },
    patterns: {
      label_double_top: "Doppelspitze",
      label_double_bottom: "Doppelboden",
      status_confirmed: "bestätigt",
      status_forming: "in Bildung",
      status_invalidated: "invalidiert",
      invalidated_badge: "✗ INVALIDIERT",
      invalidated_reason_doubletop: "Preis schloss über den Spitzen",
      invalidated_reason_doublebottom: "Preis schloss unter den Tiefs",
      invalidated_reason_hs: "Preis schloss über dem Kopf",
      invalidated_reason_inv_hs: "Preis schloss unter dem Kopf",
      invalidated_reason_triangle_asc: "Preis brach nach unten (Asc erwartete bullischen Ausbruch)",
      invalidated_reason_triangle_desc: "Preis brach nach oben (Desc erwartete bearischen Ausbruch)",
      tooltip_invalidation: "Invalidierung @ {price}",
      no_pattern: "Kein Muster erkannt",
      neckline_at: "Neckline bei {price}",
      pending_break: "Neckline-Bruch ausstehend",
      pending_break_triangle: "Apex ausstehend",
      triangle_ascending: "Aufsteigendes Dreieck",
      triangle_descending: "Absteigendes Dreieck",
      triangle_symmetric: "Symmetrisches Dreieck",
      tooltip_title_top: "Doppelspitze · {status}",
      tooltip_title_bottom: "Doppelboden · {status}",
      tooltip_peak1: "Spitze 1",
      tooltip_peak2: "Spitze 2",
      tooltip_valley: "Tal (Neckline)",
      tooltip_bottom1: "Tief 1",
      tooltip_bottom2: "Tief 2",
      tooltip_ridge: "Kamm (Neckline)",
      tooltip_high_pivot: "Hoch-Pivot",
      tooltip_low_pivot: "Tief-Pivot",
      tooltip_neckline: "Neckline",
      tooltip_break: "Bruch",
      tooltip_calibrated: "Toleranz {coin}: ±{tol}%",
      tooltip_fallback: "Pooled-Toleranz: ±{tol}% ({coin} nicht kalibriert)",
      tooltip_triangle_flat: "Flat {coin}: ≤{flat}%/Kerze",
      tooltip_triangle_flat_pooled: "Pooled Flat: ≤{flat}%/Kerze ({coin} nicht kalibriert)",
      label_hs: "Kopf-Schulter-Formation",
      label_inv_hs: "Inverse Kopf-Schulter-Formation",
      tooltip_ls: "Linke Schulter",
      tooltip_head: "Kopf",
      tooltip_rs: "Rechte Schulter",
      tooltip_neckline_diag: "Neckline (diagonal)",
      tooltip_head_diff: "Δ Kopf-Schultern",
      tooltip_shoulder_diff: "Δ zwischen Schultern",
      tooltip_hch_calibrated: "Kopf ≥ {head}% · Δ Schultern ≤ {shoulder}% ({coin})",
      tooltip_hch_pooled: "Kopf ≥ {head}% · Δ Schultern ≤ {shoulder}% (pooled, {coin} nicht kalibriert)",
      candle_hammer: "Hammer",
      candle_hanging_man: "Hanging Man",
      candle_inverted_hammer: "Inverted Hammer",
      candle_shooting_star: "Shooting Star",
      candle_doji: "Doji",
      candle_engulfing_bull: "Bullisches Engulfing",
      candle_engulfing_bear: "Bearisches Engulfing",
      candle_signal_bullish: "bullisch",
      candle_signal_bearish: "bearisch",
      candle_signal_neutral: "neutral",
      candle_body_ratio: "Körper / Range",
      candle_engulf_ratio: "Engulf-Verhältnis",
      candle_lower_wick: "Unterer Docht",
      candle_upper_wick: "Oberer Docht",
      candle_drift: "Drift (ctx)",
      candle_no_pattern: "Kein Kerzenmuster",
      candle_legend_title: "Kerzen",
      candle_legend_doji: "Doji",
      candle_legend_hammer: "Hammer · Hanging Man",
      candle_legend_inv_hammer: "Inv. Hammer · Shooting Star",
      candle_legend_engulfing: "Engulfing",
      candle_legend_cluster: "Cluster (N benachbarte Kerzen)",
      candle_legend_collapse: "Legende einklappen",
      candle_legend_expand: "Legende erweitern",
      candle_legend_count: "{n} Muster im Bereich",
      drawing: {
        toggle_title: "Manuelle Zeichenwerkzeuge",
        toggle_label: "Zeichnen",
        tool_cursor: "Cursor (Pan/Zoom)",
        tool_line: "Trendlinie",
        tool_horizontal: "Horizontale Linie",
        tool_vertical: "Vertikale Linie",
        tool_rect: "Rechteck",
        tool_text: "Text",
        tool_eraser: "Löschen",
        tool_magnet: "Magnet: an Kerze anpassen (OHLC)",
        tool_measure: "Messwerkzeug (transient)",
        tool_fib_ret: "Fibonacci Retracement",
        tool_fib_ext: "Fibonacci Extension",
        tool_channel: "Parallelkanal (3 Klicks)",
        tool_position: "Long/Short-Position (3 Klicks)",
        tool_circle: "Kreis",
        tool_ellipse: "Ellipse",
        tool_triangle: "Dreieck (3 Klicks)",
        tool_freehand: "Freihandpinsel",
        tool_polyline: "Polylinie (Doppelklick/Enter)",
        tool_callout: "Callout (Pfeil + Text)",
        tool_flag: "Flag / Wegweiser",
        tool_fib_timezone: "Fib Time Zone",
        tool_fib_speedfan: "Fib Speed Resistance Fan",
        tool_fib_wedge: "Fib Wedge",
        tool_xabcd: "XABCD (5 Klicks)",
        tool_cypher: "Cypher (5 Klicks)",
        tool_three_drives: "Three Drives (3 Klicks)",
        tool_elliott_imp: "Elliott Impulse (5 Klicks)",
        tool_elliott_corr: "Elliott Correction (3 Klicks)",
        tool_gann_fan: "Gann Fan (2 Anker)",
        tool_gann_box: "Gann Box (2 Anker)",
        tool_highlighter: "Textmarker",
        tool_pitchfork: "Andrews Pitchfork (3 Klicks)",
        tool_fib_channel: "Fib Channel",
        tool_fib_ext_trend: "Fib Extension nach Trend (3 Klicks)",
        tool_forecast: "Forecast / Projektion",
        tool_price_range: "Range messen (Preis)",
        tool_date_range: "Range messen (Datum)",
        tool_date_price_range: "Range messen (Datum + Preis)",
        tool_abcd: "Manuelles ABCD (4 Klicks)",
        tool_head_shoulders: "Kopf und Schultern (7 Klicks)",
        tool_triangle_pattern: "Dreieck (chartistisch, 4 Klicks)",
        tool_cycle_lines: "Zyklische Linien",
        tool_bars_pattern: "Balkenmuster (erfassen + repositionieren)",
        tool_ray: "Ray (unendliche Linie in eine Richtung)",
        tool_horizontal_ray: "Horizontal Ray (nur nach rechts)",
        tool_vertical_ray: "Vertical Ray (nur nach oben)",
        tool_flag_chartist: "Flag / Wimpel / Keil chartistisch (4 Klicks)",
        tool_schiff_pitchfork: "Schiff Pitchfork (3 Klicks)",
        tool_modified_schiff_pitchfork: "Modified Schiff Pitchfork (3 Klicks)",
        tool_cup_handle: "Cup & Handle (5 Klicks)",
        tool_share: "Zeichnungen als Link teilen",
        share_empty: "Keine Zeichnungen zum Teilen vorhanden",
        share_copied: "Permalink kopiert ({n} Zeichnungen · {kb} KB)",
        share_imported: "{n} Zeichnungen importiert",
        share_fallback: "Kopiere diesen Link:",
        group_lineas: "Linien",
        group_fib: "Fibonacci und Gann",
        group_patrones: "Muster",
        group_prediccion: "Vorhersage und Messung",
        group_formas: "Formen",
        group_anotacion: "Annotation",
        toggle_persistent: "Persistenter Zeichenmodus",
        toggle_lock_all: "Alle Zeichnungen sperren",
        toggle_hide_all: "Alle Zeichnungen ausblenden",
        ctx_lock: "Sperren",
        ctx_unlock: "Entsperren",
        ctx_hide: "Ausblenden",
        ctx_show: "Anzeigen",
        ctx_clone: "Duplizieren",
        ctx_delete: "Löschen",
        ctx_color: "Farbe",
        ctx_width: "Stärke",
        ctx_width_thin: "Dünn",
        ctx_width_normal: "Normal",
        ctx_width_thick: "Dick",
        ctx_width_bold: "Fett",
        ctx_color_custom: "Benutzerdefiniert",
        ctx_width_locked_tooltip: "Fixiert, um Textmarker-Effekt beizubehalten",
        ctx_apply_to_type: "Stil auf alle anwenden ({n})",
        undo_empty: "Keine weiteren Schritte zum Rückgängigmachen",
        redo_empty: "Keine weiteren Schritte zum Wiederherstellen",
        prompt_flag: "Flag-Label:",
        prompt_callout: "Callout-Text:",
        tool_clear_all: "Alle Zeichnungen löschen",
        prompt_text: "Text:",
        confirm_clear_all: "Alle Zeichnungen dieser Ansicht löschen?",
      },
    },
  },
  "zh-CN": {
    title: "流动性地图",
    subtitle: "聚合强制平仓地图 · 12个交易所",
    live: "实时",
    exchanges: "交易所",
    loading: "加载中…",
    guest_title: "需要免费账户",
    guest_sub: "Liquidity Map 显示来自 12 家交易所的实时清算集群聚合数据。30 秒创建免费账户，即可获得完整试用权限。",
    guest_cta_register: "创建免费账户",
    guest_cta_login: "我已有账户",
    err_insufficient: "当前数据不足。正在重试…",
    err_load: "无法加载数据。正在重试…",
    coins: {
      BTC: "Bitcoin",
      ETH: "Ethereum",
      SOL: "Solana",
      BNB: "BNB",
      XRP: "XRP",
      ZEC: "Zcash",
    },
    stats: {
      price: "价格",
      change24: "24小时%",
      oi: "未平仓合约",
      liq_longs: "做多强制平仓敞口",
      liq_shorts: "做空强制平仓敞口",
      liq_longs_tooltip: "基于未平仓合约和Cluster密度的估算强制平仓敞口。实时实际强制平仓数据：即将推出。",
      liq_shorts_tooltip: "基于未平仓合约和Cluster密度的估算强制平仓敞口。实时实际强制平仓数据：即将推出。",
      liq_longs_real: "做多强制平仓 24小时",
      liq_shorts_real: "做空强制平仓 24小时",
      liq_real_tooltip: "过去24小时内来自OKX、Bitget和Hyperliquid的实际聚合强制平仓数据。不包括Binance/Bybit(地理限制)。",
      liq_real_badge_live: "实时 · OKX/BG/HL",
      liq_real_badge_partial: "部分 · {n}/3个数据源",
      liq_real_badge_degraded: "降级 · 1/3个数据源",
      liq_real_badge_offline: "离线 · 无数据源",
      liq_real_badge_warming: "预热中 · 剩余{m}分钟",
      liq_real_partial_hl_note: "Hyperliquid未列出此币种。",
      cluster_max: "最大Cluster",
    },
    wyckoff: {
      title_overline: "分析",
      title: "市场结构",
      open_btn_label: "📐 结构",
      open_btn_title: "查看市场结构分析(区间、事件、背景)",
      loading: "加载分析中…",
      error: "无法加载分析。正在重试…",
      range_section_title: "活跃区间",
      ranging_yes: "✓ 是",
      ranging_no: "— 未检测到",
      confidence: "置信度",
      range_high: "顶部",
      range_low: "底部",
      midpoint: "中点",
      range_pct: "振幅",
      window_label: "窗口",
      duration_label: "区间持续时间",
      duration_tier_extended: "延长盘整",
      duration_tier_major: "主要压缩",
      candles_unit: "根K线",
      no_range_hint: "价格在此时间周期内未显示明确区间。尝试更大的周期(4小时、1天)。",
      events_section_title: "检测到的事件",
      no_events: "此时间周期内无相关事件。",
      spring_label: "可能的Spring",
      utad_label: "可能的UTAD",
      sc_label: "可能的Selling Climax",
      bc_label: "可能的Buying Climax",
      cluster_at: "Cluster",
      conviction_high: "高确信度",
      conviction_medium: "中等确信度",
      conviction_low: "低确信度",
      conviction_unknown: "确信度未定义",
      cluster_section_title: "Cluster背景",
      cluster_max: "主要",
      cluster_second: "次要",
      cluster_hint: "强制平仓Cluster是Wyckoff区间的Creek/Ice——结构可能突破或维持的区域。",
      badge_ranging: "📐 活跃区间 · {tf}",
      badge_no_range: "📐 结构 · {tf}",
      share_to_shadow: "分享到Shadow",
      share_capture_failed: "无法捕获分析",
    },
    trial: {
      days_left_one: "剩余1天",
      days_left_many: "剩余{n}天",
      expired_title: "您的免费试用已结束",
      expired_strong: "免费试用",
      expired_sub: "解锁包含12个交易所实时数据的流动性地图。",
      cta_lifetime: "获取PRO终身访问权限 →",
      cta_rbl: "使用R₿L链上支付享5折",
      cta_back: "返回首页",
      lifetime_note: "⏳ 终身优惠有效期至2026年8月2日",
      pro_active: "PRO已激活",
    },
    cascade: {
      source_label: "数据源",
      predictor_ia_label: "AI预测器",
      cascade_timer_label: "连环爆仓计时器",
      info_aria: "如何计算此数据源",
      predictor_ia_info: "由AI(Claude)根据实时市场背景生成的估算:价格、Cluster、距离、资金费率、近期强制平仓。这是定性分析,而非固定公式。事后根据实际价格(触及后反弹)进行验证。",
      cascade_timer_info: "使用量化公式计算的估算:价格向Cluster移动的历史速度、资金费率、做多/做空强制平仓比率,并根据Cluster的验证质量进行调整。事后根据实际价格(触及后反弹)进行验证。",
      analysis_low_score: "低风险 — 详细AI分析从评分31/100开始激活。",
      coverage_disclaimer: "您访问最多的币种覆盖范围更大 — 浏览标签以扩展其他币种的历史记录。",
      monitoring_sr: "监测中 — 尚未确认设置",
      monitoring_predictor: "监测中 — 尚未确认预测",
      risk_imminent: "连环爆仓即将发生",
      risk_high: "高风险",
      risk_moderate: "中等风险",
      risk_low: "低风险",
      label_price: "价格",
      label_cluster: "集群",
      label_distance: "距离",
      analyzing_ai: "正在使用RE₿EL AI分析...",
      updated_ago: "{n}秒前更新",
      cache_active: "缓存活跃",
      local_analysis: "本地分析",
      history_btn: "历史记录",
      history_btn_title: "打开'近期预测'面板(经touch-then-bounce验证),筛选为当前币种。",
      zone_critical: "⚡ 关键区域",
      estimated_cascade: "⏱️ 预计连环爆仓",
      pressure_relieved: "⏸ 压力缓解 — 价格远离集群",
      cluster_reached: "⚡ 已触及集群 — 连环爆仓已启动",
      probability: "概率",
      validated_footer: "已验证:{venues}个交易所 · {pct}%真实清算",
      trend_lateral: "横盘",
      trend_bullish: "看涨",
      trend_bearish: "看跌",
      history_title: "连环爆仓历史",
      history_empty: "{coin}无记录警报",
      history_close_aria: "关闭历史记录",
      banner_close_aria: "关闭横幅",
    },
    toolbar: {
      whales: "🐋 巨鲸",
      whales_title: "显示/隐藏巨鲸(>$1M)和中型订单($100K+)",
      sr_ai: "📐 支撑阻力AI",
      sr_ai_title: "AI检测的支撑位和阻力位",
      sr_setups_hot: "检测到{n}个高概率设置",
      range: "↕ 区间",
      range_title: "交易区间:可见K线的最高价/最低价(适应笔刷)",
      trendline: "📈 趋势",
      trendline_title: "趋势线:连接近期枢轴点并延伸",
      patterns: "◆ 形态",
      patterns_title: "图表形态:双顶/双底、三角形和头肩顶(按币种校准)",
      candles: "🕯 蜡烛图",
      candles_title: "K线形态:锤子、上吊线、倒锤子、流星、十字星、吞没",
      ema: "📈 EMA",
      ema_title: "EMA 9/21/50/200带交叉检测(黄金/死亡交叉、21×50、9×21)。相关性取决于时间周期。",
      structure_default: "结构",
      historical: "📜 历史",
      historical_title: "检测到的历史设置及其真实命中率%",
      predictions: "📊 预测",
      predictions_title: "AI连环爆仓预测器的历史预测及其真实命中率%",
      timer: "⏱️ 计时器",
      timer_title: "连环爆仓计时器历史(倒计时vs实际时间)",
      stochastic: "📊 随机指标",
      stochastic_title: "随机振荡指标(K=14, D=3, Smooth=3) — 显示动量和超买/超卖区域",
    },
    stochastic: {
      overbought: "超买",
      oversold: "超卖",
      neutral: "中性",
      signal_bull: "超卖区看涨交叉",
      signal_bear: "超买区看跌交叉",
    },
    composite: {
      title: "综合信号",
      verdicts: {
        STRONG_BUY: "强烈买入",
        BUY: "买入",
        NEUTRAL: "中性",
        SELL: "卖出",
        STRONG_SELL: "强烈卖出",
      },
      presets: { conservador: "保守", balanceado: "均衡", agresivo: "激进" },
      preset_titles: {
        conservador: "保守 — 侧重 EMA 和 Wyckoff(慢速信号)",
        balanceado: "均衡 — 所有指标均匀组合",
        agresivo: "激进 — 侧重随机指标和连环爆仓(快速均值回归)",
      },
      custom_short: "自定义",
      custom_title: "配置自定义权重",
      custom_locked: "自定义功能仅限 RE₿EL PRO",
      delayed: "延迟 5 分钟",
      breakdown_title: "活跃贡献指标",
      no_signals: "无活跃信号 — 请启用图表开关",
      disclaimer: "基于活跃指标的综合评分。非投资建议。",
      contrib: {
        ema: "EMA 交叉",
        stochastic: "随机指标交叉",
        cluster: "集群距离",
        wyckoff: "Wyckoff 结构",
        cascade: "连环爆仓预测",
      },
    },
    sr_top: {
      btn_label: "🏆 顶级支撑/阻力位",
      btn_title: "按强度评分排序的跨币种顶级支撑/阻力位水平",
      panel_title: "顶级支撑/阻力位水平",
      panel_subtitle: "按综合强度评分的跨币种排名",
      tf_label: "时间周期",
      limit_label: "前",
      coin_filter_label: "币种",
      coin_all: "全部",
      empty: "此时间周期内无可用水平。",
      empty_coin: "此时间周期内{coin}无可用水平。",
      loading: "加载排名中…",
      err: "无法加载排名。正在重试…",
      col_rank: "#",
      col_coin: "币种",
      col_kind: "类型",
      col_price: "价格",
      col_score: "评分",
      col_tasa: "成功率",
      col_toques: "触及次数",
      col_dist: "距离",
      kind_R: "阻力位",
      kind_S: "支撑位",
      tier_fuerte: "强",
      tier_media: "中",
      tier_debil: "弱",
      footer_hint: "评分综合历史成功率(40%) + 触及次数(25%) + 近期度(20%) + 接近度(15%)。仅包含真实水平 — 覆盖占位符不参与排名。",
    },
    range_tooltip: {
      min_prefix: "观察到的最低",
      max_prefix: "观察到的最高",
      candle_of: "K线",
      on: "于",
    },
    trend_tooltip: {
      title: "趋势枢轴",
      anchor: "锚定点",
      intermediate: "中间枢轴",
      hint_anchor: "线条精确通过这些点。",
      hint_intermediate: "验证方向但不影响线条。",
      kind_low: "低点(swing low)",
      kind_high: "高点(swing high)",
      total_pivots: "{n}个枢轴",
      delta_summary: "Δ {pct} · {n}根K线",
      empty: "未检测到枢轴。",
    },
    patterns: {
      label_double_top: "双顶",
      label_double_bottom: "双底",
      status_confirmed: "已确认",
      status_forming: "形成中",
      status_invalidated: "已失效",
      invalidated_badge: "✗ 已失效",
      invalidated_reason_doubletop: "价格收盘高于顶部",
      invalidated_reason_doublebottom: "价格收盘低于底部",
      invalidated_reason_hs: "价格收盘高于头部",
      invalidated_reason_inv_hs: "价格收盘低于头部",
      invalidated_reason_triangle_asc: "价格向下突破(上升三角形预期看涨突破)",
      invalidated_reason_triangle_desc: "价格向上突破(下降三角形预期看跌突破)",
      tooltip_invalidation: "失效 @ {price}",
      no_pattern: "未检测到形态",
      neckline_at: "颈线位于{price}",
      pending_break: "等待突破颈线",
      pending_break_triangle: "顶点待突破",
      triangle_ascending: "上升三角形",
      triangle_descending: "下降三角形",
      triangle_symmetric: "对称三角形",
      tooltip_title_top: "双顶 · {status}",
      tooltip_title_bottom: "双底 · {status}",
      tooltip_peak1: "顶部1",
      tooltip_peak2: "顶部2",
      tooltip_valley: "谷底(颈线)",
      tooltip_bottom1: "底部1",
      tooltip_bottom2: "底部2",
      tooltip_ridge: "山脊(颈线)",
      tooltip_high_pivot: "高点枢轴",
      tooltip_low_pivot: "低点枢轴",
      tooltip_neckline: "颈线",
      tooltip_break: "突破",
      tooltip_calibrated: "{coin}容差: ±{tol}%",
      tooltip_fallback: "汇总容差: ±{tol}% ({coin}未校准)",
      tooltip_triangle_flat: "{coin}平坦度: ≤{flat}%/K线",
      tooltip_triangle_flat_pooled: "汇总平坦度: ≤{flat}%/K线 ({coin}未校准)",
      label_hs: "头肩顶",
      label_inv_hs: "倒头肩底",
      tooltip_ls: "左肩",
      tooltip_head: "头部",
      tooltip_rs: "右肩",
      tooltip_neckline_diag: "颈线(对角线)",
      tooltip_head_diff: "Δ 头部-肩部",
      tooltip_shoulder_diff: "Δ 肩部间",
      tooltip_hch_calibrated: "头部 ≥ {head}% · Δ 肩部 ≤ {shoulder}% ({coin})",
      tooltip_hch_pooled: "头部 ≥ {head}% · Δ 肩部 ≤ {shoulder}% (汇总, {coin}未校准)",
      candle_hammer: "锤子线",
      candle_hanging_man: "上吊线",
      candle_inverted_hammer: "倒锤子线",
      candle_shooting_star: "流星线",
      candle_doji: "十字星",
      candle_engulfing_bull: "看涨吞没",
      candle_engulfing_bear: "看跌吞没",
      candle_signal_bullish: "看涨",
      candle_signal_bearish: "看跌",
      candle_signal_neutral: "中性",
      candle_body_ratio: "实体 / 范围",
      candle_engulf_ratio: "吞没比率",
      candle_lower_wick: "下影线",
      candle_upper_wick: "上影线",
      candle_drift: "漂移(上下文)",
      candle_no_pattern: "无K线形态",
      candle_legend_title: "K线",
      candle_legend_doji: "十字星",
      candle_legend_hammer: "锤子线 · 上吊线",
      candle_legend_inv_hammer: "倒锤子线 · 流星线",
      candle_legend_engulfing: "吞没",
      candle_legend_cluster: "簇(N根相近K线)",
      candle_legend_collapse: "收起图例",
      candle_legend_expand: "展开图例",
      candle_legend_count: "区间内{n}个形态",
      drawing: {
        toggle_title: "手动绘图工具",
        toggle_label: "绘制",
        tool_cursor: "光标(平移/缩放)",
        tool_line: "趋势线",
        tool_horizontal: "水平线",
        tool_vertical: "垂直线",
        tool_rect: "矩形",
        tool_text: "文本",
        tool_eraser: "擦除",
        tool_magnet: "磁铁: 吸附到K线(OHLC)",
        tool_measure: "测量器(临时)",
        tool_fib_ret: "Fibonacci回撤",
        tool_fib_ext: "Fibonacci扩展",
        tool_channel: "平行通道(3次点击)",
        tool_position: "做多/做空头寸(3次点击)",
        tool_circle: "圆形",
        tool_ellipse: "椭圆",
        tool_triangle: "三角形(3次点击)",
        tool_freehand: "自由画笔",
        tool_polyline: "折线(双击/Enter)",
        tool_callout: "标注(箭头 + 文本)",
        tool_flag: "旗标 / 路标",
        tool_fib_timezone: "Fib时间区域",
        tool_fib_speedfan: "Fib速阻扇形",
        tool_fib_wedge: "Fib楔形",
        tool_xabcd: "XABCD(5次点击)",
        tool_cypher: "Cypher(5次点击)",
        tool_three_drives: "Three Drives(3次点击)",
        tool_elliott_imp: "Elliott冲击波(5次点击)",
        tool_elliott_corr: "Elliott调整波(3次点击)",
        tool_gann_fan: "Gann扇形(2个锚点)",
        tool_gann_box: "Gann框(2个锚点)",
        tool_highlighter: "荧光笔",
        tool_pitchfork: "Andrews干草叉(3次点击)",
        tool_fib_channel: "Fib通道",
        tool_fib_ext_trend: "Fib趋势扩展(3次点击)",
        tool_forecast: "预测 / 投影",
        tool_price_range: "测量区间(价格)",
        tool_date_range: "测量区间(日期)",
        tool_date_price_range: "测量区间(日期 + 价格)",
        tool_abcd: "手动ABCD(4次点击)",
        tool_head_shoulders: "头肩(7次点击)",
        tool_triangle_pattern: "三角形(图表形态, 4次点击)",
        tool_cycle_lines: "周期线",
        tool_bars_pattern: "K线形态(捕获 + 重新定位)",
        tool_ray: "射线(一个方向的无限线)",
        tool_horizontal_ray: "水平射线(仅向右)",
        tool_vertical_ray: "垂直射线(仅向上)",
        tool_flag_chartist: "旗形 / 三角旗 / 楔形图表形态(4次点击)",
        tool_schiff_pitchfork: "Schiff干草叉(3次点击)",
        tool_modified_schiff_pitchfork: "改进Schiff干草叉(3次点击)",
        tool_cup_handle: "杯柄形态(5次点击)",
        tool_share: "以链接分享绘图",
        share_empty: "无绘图可分享",
        share_copied: "永久链接已复制({n}个绘图 · {kb} KB)",
        share_imported: "已导入{n}个绘图",
        share_fallback: "复制此链接:",
        group_lineas: "线条",
        group_fib: "Fibonacci和Gann",
        group_patrones: "形态",
        group_prediccion: "预测和测量",
        group_formas: "形状",
        group_anotacion: "标注",
        toggle_persistent: "持续绘图模式",
        toggle_lock_all: "锁定所有绘图",
        toggle_hide_all: "隐藏所有绘图",
        ctx_lock: "锁定",
        ctx_unlock: "解锁",
        ctx_hide: "隐藏",
        ctx_show: "显示",
        ctx_clone: "克隆",
        ctx_delete: "删除",
        ctx_color: "颜色",
        ctx_width: "粗细",
        ctx_width_thin: "细",
        ctx_width_normal: "正常",
        ctx_width_thick: "粗",
        ctx_width_bold: "加粗",
        ctx_color_custom: "自定义",
        ctx_width_locked_tooltip: "固定以保持荧光笔效果",
        ctx_apply_to_type: "将样式应用于全部({n})",
        undo_empty: "没有更多步骤可撤销",
        redo_empty: "没有更多步骤可重做",
        prompt_flag: "旗标标签:",
        prompt_callout: "标注文本:",
        tool_clear_all: "清除所有绘图",
        prompt_text: "文本:",
        confirm_clear_all: "清除此视图的所有绘图?",
      },
    },
  },
};

export const tLm = (lang) => LIQMAP_T[lang] || LIQMAP_T.es;
